<template>
  <div class="three-d-view">
    <div class='graph-view_checkbox' v-show="browserType !== 'ie'">
      <div class='Projector_checkbox'>
        <el-checkbox v-model='threeD_PJChecked' :disabled="isCheckBoxDisable"><span>{{$t('T_CHANGE_PJ_POS')}}</span></el-checkbox>
      </div>
    </div>
    <div class="graph-view-text">
      <div class="graph-view_title">
        <div class="threed-img"></div>
        <span>{{$t('T_3D_VIEW')}}</span>
      </div>
    </div>
    <div class="threedcontainer" ref="threedcontainer" v-show="browserType !== 'ie'">
    </div>
    <div v-show="browserType === 'ie'" v-html = "$t('T_NOT_SUPPORT_3D')" class="notSupport3D"></div>
  </div>
</template>

<script>
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import {TransformControls} from 'three/examples/jsm/controls/TransformControls'
import { ConvexBufferGeometry } from 'three/examples/jsm/geometries/ConvexGeometry.js'
import { debounce } from 'lodash'

// import { WEBGL } from 'three/examples/jsm/WebGL.js'
import {mapState, mapMutations} from 'vuex'

export default {
  name: 'threeDView',
  props: ['PJModel'],
  data () {
    return {
      isDraggingPj: false,
      ratio: 100,
      wallThickness: 0.2,
      roomWInit: 500,
      roomHInit: 350,
      roomDInit: 1000,
      outOfRange: false,
      newVector: new THREE.Vector3(),
      wallOffset: 0.01,

      PJModelGroup: '',
      linePointArr: [],
      topLineP: [],
      helpLineP: [],
      edgePoints: [],
      dashDatas: [],
      avaiRange: [],
      lensShiftScreenP: [],
      lensShiftRangeP: [],
      outRoomHeight: 0,
      outRoomWidth: 0,
      backVLensShiftNow: this.vLensShiftNow,
      backHLensShiftNow: this.hLensShiftNow,
      // scaleRatio: 10,
      // curveRoomInfo: {H: 0, W: 0, D: 0},
      debouncedSetLines: null,
      cameraCurve: null,
      activeCamera: null,
      isLShaped: this.$commonViewJs.isLShaped(), // 是否为L字投影
      isLShaped01: this.$commonViewJs.isLShaped01() // 是否为L字投影桌面位置或者吊顶位置
    }
  },
  methods: {
    ...mapMutations([
      'SET_GRAPH_ROOMD',
      'SET_GRAPH_ROOMW',
      'SET_GRAPH_ROOMH',
      'PJX',
      'PJY',
      'PJZ',
      'SCRNW',
      'SCRNH',
      'SCREENSIZE',
      'SET_DRAWDATA',
      'SET_SCREENEDGESDRAWDATA',
      'SET_BLACKDRAWDATA',
      'SET_RANGEDRAWDATA',
      'SET_CENTERPOINTDATA',
      'SET_VLENSSHIFT',
      'SET_HLENSSHIFT',
      'SET_INITSCREENSIZEW',
      'SET_INITSCREENSIZEH',
      'SET_DASHDATA',
      'SET_DASHDATAREMAIN',
      'SET_ISTOUCH',
      'SET_SCREEN4POINT',
      'SET_FLTOL',
      'SET_FLTOB',
      'SET_TOUCHWALLFLAG',
      'SET_THREEDPJCHECKED',
      'SET_CURVECENTER',
      'SET_ISONCORNERAREAS',
      'SET_CORNERCORAREAS',
      'SET_CURVERADIUS',
      'SET_CURVECENTRALANGLE',
      'SET_TEMVLENSSHIFT'
    ]),
    init () {
      // if (WEBGL.isWebGL2Available() === false) {
      //   document.body.appendChild(WEBGL.getWebGL2ErrorMessage())
      // }
      this.isLShaped = this.$commonViewJs.isLShaped()
      this.isLShaped01 = this.$commonViewJs.isLShaped01()
      this.roomWInit = this.houseInfo.roomW ? this.houseInfo.roomW : this.roomWInit
      this.roomHInit = this.houseInfo.roomH ? this.houseInfo.roomH : this.roomHInit
      this.roomDInit = this.houseInfo.roomD ? this.houseInfo.roomD : this.roomDInit
      this.container = this.$refs.threedcontainer
      this.innerWidth = this.container.offsetWidth
      this.innerHeight = this.container.offsetHeight
      this.scene = new THREE.Scene()

      this.camera = new THREE.PerspectiveCamera(50, this.innerWidth / this.innerHeight, 0.01, 1000)
      this.camera.position.set(-8, 1, 12)

      // 曲面画面表示时使用的 相机
      this.cameraCurve = new THREE.PerspectiveCamera(50, this.innerWidth / this.innerHeight, 0.01, 1000)
      this.cameraCurve.position.set(-0.1372, 0.2107, 1.8381)
      this.activeCamera = this.searchTabActive === 'CurvedSurface' ? this.cameraCurve : this.camera
      this.addToScene(this.activeCamera)

      // // 创建坐标轴辅助器（参数表示轴的长度）
      // const axesHelper = new THREE.AxesHelper(5)
      // this.addToScene(axesHelper)

      this.renderer = new THREE.WebGLRenderer({
        antialias: true
      })
      // this.renderer = new THREE.WebGLRenderer({antialias: true, logarithmicDepthBuffer: true})

      // this.renderer.setSize(this.innerWidth, this.innerHeight)
      this.renderer.setClearColor(0xFFFFFF)
      this.renderer.clear()
      this.container.appendChild(this.renderer.domElement)
      this.OrbitControls = new OrbitControls(this.activeCamera, this.renderer.domElement)
      this.OrbitControls.enableKeys = false
      // this.OrbitControls.enableZoom = false
      // this.OrbitControls.enablePan = false
      this.createScene()
      window.addEventListener('resize', this.onWindowResize, false)
    },
    switchCamera () {
      this.activeCamera = this.activeCamera = this.searchTabActive === 'CurvedSurface' ? this.cameraCurve : this.camera
      if (this.OrbitControls) {
        this.OrbitControls.object = this.activeCamera
        this.OrbitControls.update()
      }
      if (this.transformCtrl) {
        this.transformCtrl.camera = this.activeCamera
      }
    },
    setPJModelAttibuteAndAddToScene (status) {
      if (this.browserType === 'other') {
        this.findCurrentPJModelByType()
      } else if (this.browserType === 'edgeOrIE') {
        this.createPJBox()
      }
      this.setPJModelAttibute()
      this.addTransformControl()
      this.addToScene(this.PJModelGroup)
      if (this.PJModelGroup && !this.PJModelGroup.visible) {
        this.PJModelGroup.visible = true
      }
    },
    createPJBox () {
      this.PJModelGroup = new THREE.Mesh(new THREE.CubeGeometry(1, 0.5, 1),
        new THREE.MeshBasicMaterial({
          color: 0x696969
        })
      )
    },
    addToScene (item) {
      if (!this.isUSTWall) {
        this.scene.add(item)
      }
    },
    findCurrentPJModelByType () {
      let pjModel = null
      if (this.projectorImgType === 0) {
        pjModel = this.PJModelGroupType0
      } else if (this.projectorImgType === 1) {
        pjModel = this.PJModelGroupType1
      } else if (this.projectorImgType === 3) {
        pjModel = this.PJModelGroupType3
      } else {
        pjModel = this.PJModelGroupType2
      }
      this.PJModelGroup = pjModel
    },
    setPJModelAttibute () {
      let pointA = this.$commonThreeD.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getAx(), this.$commonViewJs.getAy(), this.$commonViewJs.getAz()))
      if (!this.PJModelGroup) {
        return
      }
      this.PJModelGroup.position.set(pointA.x, pointA.y, pointA.z)
      if (this.browserType === 'other') {
        this.$commonThreeD.setPJModelScale(this.projectorImgType, this.PJModelGroup, false, this.searchTabActive === 'CurvedSurface')
        this.setPJModelRotation()
      }
    },
    setPJModelRotation () {
      if (!this.PJModelGroup) {
        return
      }
      let val = this.$commonThreeD.getPJModelInitRotation(this.projectorImgType, this.position)
      // console.log('console.log(this.PJModelGroup.rotation.order)', this.PJModelGroup.rotation.order)
      this.PJModelGroup.rotation.set(val.x, val.y, val.z)
      if (this.hAngleFlag) {
        this.$commonThreeD.setPjModelhAngle(this.hAngle, this.PJModelGroup, this.projectorImgType, val, this.position)
      } else {
        this.$commonThreeD.setPjModelhAngle(0, this.PJModelGroup, this.projectorImgType, val, this.position)
      }
      if (this.vAngleFlag) {
        this.$commonThreeD.setPjModelvAngle(this.vAngle, this.PJModelGroup, this.projectorImgType, val)
      } else {
        this.$commonThreeD.setPjModelvAngle(0, this.PJModelGroup, this.projectorImgType, val)
      }
    },
    addTransformControl () {
      if (!this.transformCtrl) {
        this.transformCtrl = new TransformControls(this.activeCamera, this.renderer.domElement)
      }
      if (this.PJModelGroup) {
        if (this.threeD_PJChecked) {
          this.transformCtrl.attach(this.PJModelGroup)
        }
        this.transformCtrl.addEventListener('dragging-changed', function (event) {
          this.OrbitControls.enabled = !event.value
        }.bind(this))
        this.transformCtrl.addEventListener('mouseDown', this.onTransformMouseDown)
        this.transformCtrl.addEventListener('objectChange', this.OnProjectorDrag)
        document.addEventListener('mouseup', this.onTransformMouseUp)
        if (this.browserType !== 'ie') {
          this.addToScene(this.transformCtrl)
        }
      }
    },
    onWindowResize () {
      this.innerWidth = this.container.offsetWidth
      this.innerHeight = this.container.offsetHeight
      this.camera.aspect = this.innerWidth / this.innerHeight
      this.camera.updateProjectionMatrix()
      this.cameraCurve.aspect = this.innerWidth / this.innerHeight
      this.cameraCurve.updateProjectionMatrix()

      this.renderer.setSize(this.innerWidth, this.innerHeight)
    },
    createScene () {
      this.createRoomGeometry()
      this.createCurveWall()
      this.setLines(true)
      if (this.browserType !== 'ie') {
        this.createLight()
        this.initFlatColor()
      }
      this.animate()
    },
    createRoomGeometry () {
      let point = this.getRoomCubePoint()
      let loader = new THREE.TextureLoader()
      let width = this.roomWInit / 100
      let depth = this.roomDInit / 100
      let height = this.roomHInit / 100
      let wallImg = loader.load(require('@/assets/parts/graph/wall.png'))
      let bigWallImg = loader.load(require('@/assets/parts/graph/bigWall.png'))
      let material = new THREE.MeshBasicMaterial({ map: wallImg, opacity: 0.7, side: THREE.DoubleSide, transparent: true })
      let curtainMtl = new THREE.MeshBasicMaterial({ map: wallImg, side: THREE.DoubleSide, transparent: true })
      let bigWallMtl = new THREE.MeshBasicMaterial({ map: bigWallImg, opacity: 0.1, side: THREE.DoubleSide, transparent: true })
      let leftMaterial = new THREE.MeshBasicMaterial({ map: wallImg, opacity: 0.7, side: THREE.BackSide, transparent: true })

      let frontWallGeo = new THREE.BoxBufferGeometry(width, height, this.wallThickness)
      let frontWallImgGeo = new THREE.PlaneGeometry(width, height)
      let bigWallImgGeo = new THREE.PlaneGeometry(100, 100)
      this.frontWall = this.$commonThreeD.createWall(frontWallGeo)
      this.frontWallImg = new THREE.Mesh(frontWallImgGeo, material)
      this.curtainImg = new THREE.Mesh(frontWallImgGeo, curtainMtl)
      this.frontBigWallImg = new THREE.Mesh(bigWallImgGeo, bigWallMtl)
      this.frontBigWallImg.renderOrder = 1
      this.frontWallImg.renderOrder = 5

      let rightWallGeo = new THREE.BoxBufferGeometry(depth, height, this.wallThickness)
      let rightWallImgGeo = new THREE.PlaneBufferGeometry(depth, height)
      this.rightWall = this.$commonThreeD.createWall(rightWallGeo)
      this.rightWallImg = new THREE.Mesh(rightWallImgGeo, material)
      this.rightWall.rotation.y = -Math.PI / 2
      this.rightWallImg.rotation.y = -Math.PI / 2

      let leftWallImgGeo = new THREE.PlaneBufferGeometry(depth, height)
      this.leftWallImg = new THREE.Mesh(leftWallImgGeo, leftMaterial)
      this.leftWallImg.rotation.y = -Math.PI / 2

      this.backWallImg = new THREE.Mesh(frontWallImgGeo, curtainMtl)
      this.floorBigWallImg = new THREE.Mesh(bigWallImgGeo, bigWallMtl)
      this.floorBigWallImg.renderOrder = 1
      this.roofBigWallImg = new THREE.Mesh(bigWallImgGeo, bigWallMtl)
      this.roofBigWallImg.renderOrder = 1

      this.createFloor(width, depth)
      this.createRoof()

      this.setRoomGeometryPosition(point)
      if (this.browserType !== 'ie') {
        // if (!this.isCurvedWallDisplay) {
        this.addToScene(this.frontWall)
        // }
        this.addToScene(this.rightWall)
        this.addToScene(this.floor)
      }
      // this.addToScene(this.frontBigWallImg)
      // this.addToScene(this.frontWallImg)
      // this.addToScene(this.curtainImg)
      // this.addToScene(this.rightWallImg)

      // this.addToScene(this.leftWallImg)
      // this.addToScene(this.roof)
      // this.addToScene(this.floorCurtain)
      // this.addToScene(this.roofCurtain)
      // this.addToScene(this.backWallImg)
    },
    // createWall (geometry) {
    //   let wallMaterial = new THREE.MeshBasicMaterial({ color: 0xffffff, transparent: true, opacity: 0.5 })
    //   let wallEdgesMtl = new THREE.LineBasicMaterial({color: 0xff666666, linewidth: 1})

    //   let wall = new THREE.Mesh(geometry, wallMaterial)
    //   let wallEdges = new THREE.EdgesGeometry(geometry)
    //   let wallLine = new THREE.LineSegments(wallEdges, wallEdgesMtl)
    //   let wallGroup = new THREE.Group()

    //   wallGroup.add(wall)
    //   wallGroup.add(wallLine)
    //   return wallGroup
    // },
    createFloor (width, depth) {
      this.floor = this.$commonThreeD.createFloor(width, depth)
      this.floor.rotation.x = -Math.PI / 2
      this.floorBigWallImg.rotation.x = -Math.PI / 2

      let geometry = new THREE.PlaneBufferGeometry(width, depth)
      let curtainMtl = new THREE.MeshBasicMaterial({ color: 0xffffff, side: THREE.DoubleSide, transparent: true })
      this.floorCurtain = new THREE.Mesh(geometry, curtainMtl)
      this.floorCurtain.rotation.x = -Math.PI / 2
    },
    // createGridFloor () {
    //   this.gridFloor = new THREE.GridHelper(5000, 300)
    //   this.gridFloor.position.y = this.graph.scrnH * (-1 / 2) / this.scaleRatio
    //   this.gridFloor.material.opacity = 0.25
    //   this.gridFloor.material.transparent = true
    //   this.gridFloor.visible = false
    //   this.addToScene(this.gridFloor)
    // },
    createRoof () {
      let width = this.roomWInit / 100
      let depth = this.roomDInit / 100
      let loader = new THREE.TextureLoader()
      let floorImg = loader.load(require('@/assets/parts/graph/floor.png'))

      let geometry = new THREE.PlaneBufferGeometry(width, depth)
      let material = new THREE.MeshBasicMaterial({ map: floorImg, opacity: 0.7, side: THREE.BackSide, transparent: true }, this.animate())
      this.roof = new THREE.Mesh(geometry, material)
      this.roof.rotation.x = -Math.PI / 2
      this.roofBigWallImg.rotation.x = -Math.PI / 2

      let curtainMtl = new THREE.MeshBasicMaterial({ color: 0xffffff, side: THREE.DoubleSide, transparent: true })
      this.roofCurtain = new THREE.Mesh(geometry, curtainMtl)
      this.roofCurtain.rotation.x = -Math.PI / 2
    },
    setRoomGeometryPosition (point) {
      this.frontWall.position.setZ(point.b2.z - this.wallThickness / 2 - this.wallOffset)
      this.frontWallImg.position.setZ(point.b2.z)
      this.curtainImg.position.setZ(point.b2.z + (this.isLShaped01 ? 0 : this.offsetVal))
      this.frontBigWallImg.position.setZ(point.b2.z)

      this.rightWall.position.setX(point.threeD3.x + this.wallThickness / 2 + this.wallOffset)
      this.rightWallImg.position.setX(point.threeD3.x)
      this.leftWallImg.position.setX(-point.threeD3.x)
      this.rightWallImg.position.setZ(this.offsetVal)
      this.leftWallImg.position.setZ(this.offsetVal)

      this.floor.position.setY(point.c3.y)
      this.roof.position.setY(-point.c3.y)
      this.floorBigWallImg.position.setY(point.c3.y)
      this.floorCurtain.position.setY(point.c3.y + (this.isLShaped01 ? this.offsetVal : 0))
      this.roofBigWallImg.position.setY(-point.c3.y)
      this.roofCurtain.position.setY(-point.c3.y - (this.isLShaped01 ? this.offsetVal : 0))
      this.backWallImg.position.setZ(-point.b2.z)
    },
    disposeCurveWall () {
      if (this.cylinder) {
        this.scene.remove(this.cylinder)
        this.cylinderGeo.geometry.dispose()
        this.cylinderWithSideWallGeo.geometry.dispose()
        this.cylinder = null
        this.cylinderGeo = null
        this.cylinderWithSideWallGeo = null
      }
    },
    createCurveWall () {
      // 先清理旧的资源
      this.disposeCurveWall()
      // curveShape '0':垂直曲面, '1':水平曲面, '2': 平面
      // curveDirection '0':凹面, '1':凸面
      // let segmentation = 10
      let geometry, geometryWithSideWall
      // if (this.curveShape === '1') { // 水平
      let width = Math.max(this.curveChordLength / 100, 0.001)
      let height = Math.max(this.curveScreenHeight / 100, 0.001)
      // 有角度的场合画曲面，无角度的场合画平面
      if (this.curveCentralAngle) {
        let segments = Math.max(width, height) / 64
        let radiusSegments = width / segments
        let heightSegments = height / segments
        geometry = new THREE.CylinderGeometry(this.curveRadius / 100, this.curveRadius / 100, height, radiusSegments, heightSegments, true, Math.PI - this.curveCentralAngle / 2, this.curveCentralAngle)
        geometryWithSideWall = new THREE.CylinderGeometry(this.curveRadius / 100, this.curveRadius / 100, Math.max(height, 10) * 10, 32, 32, true, Math.PI / 2, Math.PI)
      } else {
        // geometry = new THREE.CylinderGeometry(this.curveRadius / 100, this.curveRadius / 100, this.curveScreenHeight / 100, 32, 32, true, Math.PI - this.curveCentralAngle / 2, this.curveCentralAngle)
        // geometryWithSideWall = new THREE.CylinderGeometry(this.curveRadius / 100, this.curveRadius / 100, this.curveScreenHeight / 100 * 10, 32, 1, true, Math.PI / 2, Math.PI)
        geometry = new THREE.PlaneGeometry(width, height, 30, 30)
        geometryWithSideWall = new THREE.PlaneGeometry(Math.max(width, 1) * 10, Math.max(height, 1) * 10, 30, 30)
      }
      let material = new THREE.MeshBasicMaterial({
        color: this.coverScreenColor,
        wireframe: true, // 网格线框
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.6,
        depthWrite: false
      })
      // let materialSide = new THREE.MeshBasicMaterial({
      //   color: '#0000ff',
      //   side: THREE.DoubleSide,
      //   transparent: true,
      //   opacity: 0.3
      // })

      this.cylinderGeo = new THREE.Mesh(geometry, material)
      this.cylinderWithSideWallGeo = new THREE.Mesh(geometryWithSideWall, material)
      // let cylinderEdges = new THREE.EdgesGeometry(geometry, 1)
      // console.log('cylinderEdges', cylinderEdges)

      // let edgesMtl = new THREE.LineBasicMaterial({color: this.$constant.greenColor, opacity: 0.5})
      // let cylinderEdgesLine = new THREE.LineSegments(cylinderEdges, edgesMtl)
      this.cylinder = new THREE.Group()
      this.cylinder.add(this.cylinderGeo)
      // this.cylinder.add(cylinderEdgesLine)
      if (this.curveShape === '0') {
        this.cylinder.rotation.z = Math.PI / 2
        this.cylinderWithSideWallGeo.rotation.z = Math.PI / 2
      }

      if (this.curveDirection === '1') {
        this.cylinder.rotation.x = Math.PI
        this.cylinderWithSideWallGeo.rotation.x = Math.PI
      }
      // let center
      // if (this.isLShaped01) {
      //   let direction = this.position === 1 ? -1 : 1
      //   center = this.$commonThreeD.transCoordToThreeDZ(this.curveCenter)
      //   if (this.curveDirection !== '1') {
      //     this.cylinder.rotation.x = Math.PI / 2 * direction
      //     this.cylinderWithSideWallGeo.rotation.x = Math.PI / 2 * direction

      //     this.cylinder.position.setY(center * direction)
      //     this.cylinderWithSideWallGeo.position.setY(center * direction)
      //   } else {
      //     direction = this.position === 1 ? 1 : -1
      //     this.cylinder.rotation.x = Math.PI / 2 * direction
      //     this.cylinderWithSideWallGeo.rotation.x = Math.PI / 2 * direction

      //     this.cylinder.position.setY(center * direction * -1)
      //     this.cylinderWithSideWallGeo.position.setY(center * direction * -1)
      //   }
      // } else {
      let center = this.$commonThreeD.transCoordToThreeDY(this.curveCenter)
      this.cylinder.position.setZ(center)
      this.cylinderWithSideWallGeo.position.setZ(center)
      // console.log('center', center)
      // }

      this.updateObjectMatrix()
      this.cylinder.renderOrder = 0
      this.addToScene(this.cylinder)

      let screenEdgesDrawData = this.setDrawData([this.getWorldVertices()])
      this.SET_SCREENEDGESDRAWDATA(screenEdgesDrawData)

      // this.addToScene(this.cylinderWithSideWallGeo)
    },
    getWorldVertices () {
      const mesh = this.cylinderGeo
      const vertices = mesh.geometry.vertices

      const worldVertices = vertices.map(v => v.clone().applyMatrix4(mesh.matrixWorld))
      // 从世界顶点中找出Y轴的最大值和最小值
      let maxY = -Infinity
      let minY = Infinity
      let maxX = -Infinity
      let minX = Infinity
      // let maxZ = -Infinity
      // let minZ = Infinity
      worldVertices.forEach(v => {
        // if (this.isLShaped01) {
        //   maxZ = Math.max(maxZ, v.z)
        //   minZ = Math.min(minZ, v.z)
        // } else {
        maxY = Math.max(maxY, v.y)
        minY = Math.min(minY, v.y)
        // }
        minX = Math.min(minX, v.x)
        maxX = Math.max(maxX, v.x)
      })
      // 根据y值分组
      // let topVertices, bottomVertices, leftVertices, rightVertices
      // if (this.isLShaped01) {
      //   // if (this.position === 1) {
      //   topVertices = worldVertices.filter(v => Math.abs(v.z - minZ) < 0.01).sort((a, b) => a.x - b.x)
      //   bottomVertices = worldVertices.filter(v => Math.abs(v.z - maxZ) < 0.01).sort((a, b) => b.x - a.x)
      //   leftVertices = worldVertices.filter(v => Math.abs(v.x - minX) < 0.01).sort((a, b) => b.z - a.z)
      //   rightVertices = worldVertices.filter(v => Math.abs(v.x - maxX) < 0.01).sort((a, b) => a.z - b.z)
      //   // } else {
      //   //   topVertices = worldVertices.filter(v => Math.abs(v.z - maxZ) < 0.01).sort((a, b) => a.x - b.x)
      //   //   bottomVertices = worldVertices.filter(v => Math.abs(v.z - minZ) < 0.01).sort((a, b) => b.x - a.x)
      //   //   leftVertices = worldVertices.filter(v => Math.abs(v.x - minX) < 0.01).sort((a, b) => a.z - b.z)
      //   //   rightVertices = worldVertices.filter(v => Math.abs(v.x - maxX) < 0.01).sort((a, b) => b.z - a.z)
      //   // }
      // } else {
      //   topVertices = worldVertices.filter(v => Math.abs(v.y - maxY) < 0.01).sort((a, b) => a.x - b.x)
      //   bottomVertices = worldVertices.filter(v => Math.abs(v.y - minY) < 0.01).sort((a, b) => b.x - a.x)
      //   leftVertices = worldVertices.filter(v => Math.abs(v.x - maxX) < 0.01).sort((a, b) => a.y - b.y)
      //   rightVertices = worldVertices.filter(v => Math.abs(v.x - minX) < 0.01).sort((a, b) => b.y - a.y)
      // }
      const topVertices = worldVertices.filter(v => Math.abs(v.y - maxY) < 0.01).sort((a, b) => a.x - b.x)
      const bottomVertices = worldVertices.filter(v => Math.abs(v.y - minY) < 0.01).sort((a, b) => b.x - a.x)
      const leftVertices = worldVertices.filter(v => Math.abs(v.x - maxX) < 0.01).sort((a, b) => a.y - b.y)
      const rightVertices = worldVertices.filter(v => Math.abs(v.x - minX) < 0.01).sort((a, b) => b.y - a.y)

      let worldPoints = []
      worldPoints.push(...topVertices)
      worldPoints.push(...rightVertices)
      worldPoints.push(...bottomVertices)
      worldPoints.push(...leftVertices)

      return worldPoints
    },
    updateCurveWall () {
      // this.scene.remove(this.cylinderWithSideWallGeo)
      this.disposeCurveWall()
      if (!this.isCurvedWallDisplay) {
        this.floor.visible = true
        this.rightWall.visible = true
        this.frontWall.visible = true
        this.$commonThreeD.setPJModelScale(this.projectorImgType, this.PJModelGroup)
        this.switchCamera()
        // this.gridFloor.visible = false
        return
      }
      this.floor.visible = false
      this.rightWall.visible = false
      this.frontWall.visible = false
      this.$commonThreeD.setPJModelScale(this.projectorImgType, this.PJModelGroup, false, true)
      this.switchCamera()
      // this.gridFloor.visible = true
      this.createCurveWall()
    },
    createLight () {
      let ambientLight = new THREE.AmbientLight(0x404040)
      this.addToScene(ambientLight)

      let pointLight = new THREE.PointLight(0xffffff)
      pointLight.position.set(-10, 5, 10)
      this.addToScene(pointLight)
    },
    setLines (status) {
      // console.log('setLines', status, new Date().getTime(), this.graph.pjY, this.graph.pjX, this.graph.pjZ)
      this.helpLineP = []
      this.removeLines()
      this.isLShaped = this.$commonViewJs.isLShaped()
      this.isLShaped01 = this.$commonViewJs.isLShaped01()
      this.updateCurveWall()
      this.updateObjectMatrix()
      // this.setCenterLine()
      this.clearPoints()
      this.createLensShiftP() // 八边形
      if (this.vLensShiftMax !== this.vLensShiftMin || this.hLensShiftMax !== this.hLensShiftMin) {
        // レンズシフトの動作について
        // 現在シフト範囲外に画面を移動させた場合、シフト量の数字を赤枠で囲む仕様になっています。
        // しかし、これだけではお客様が気づかないケースがあるため、レンズシフトの八角形以上に動かないように変更
        if (this.isTouch) {
          // シフト量の数字を赤枠で囲む場合、前回の値を使用して、グラフを更新する
          if (this.backVLensShiftNow !== undefined) this.SET_VLENSSHIFT(this.backVLensShiftNow)
          if (this.backHLensShiftNow !== undefined) this.SET_HLENSSHIFT(this.backHLensShiftNow)
          return
        } else {
          this.backVLensShiftNow = this.vLensShiftNow
          this.backHLensShiftNow = this.hLensShiftNow
        }
      }
      this.setBlackArea() // 不同aspect ratio
      this.setEdgeLines()
      this.setDashLines()
      if (!status) {
        this.updateFlatColor()
      }
    },
    curveWallPaint () {
      // console.log('this.frontFlatP.length', this.frontFlatP.length)
      // THREE.ConvexHull: The algorithm needs at least four points.(ConvexBufferGeometry)
      if (this.frontFlatP.length < 4) { return }
      var sampleClosedSpline = new ConvexBufferGeometry(this.frontFlatP)
      // // 投影的区域（浅黄色部分）
      var material = new THREE.MeshBasicMaterial({ color: 0xfbfcb5, opacity: 0.5, side: THREE.DoubleSide, transparent: true, depthWrite: false })

      this.frontMesh = new THREE.Mesh(sampleClosedSpline, material)
      this.scene.add(this.frontMesh)
      this.frontMesh.position.z += 0.05
      this.frontMesh.renderOrder = 1
      // this.frontMesh.renderOrder = 50
    },
    clearPoints () {
      this.frontFlatP = []
      this.leftFlatP = []
      this.rightFlatP = []
      this.topFlatP = []
      this.bottomFlatP = []
      this.allPoints = []
      this.lensShiftRangeP = []
      this.lensShiftScreenP = []
      this.backFlatP = []
      this.frontAllFlatP = []
      this.rightAllFlatP = []
      this.leftAllFlatP = []
      this.topAllFlatP = []
      this.bottomAllFlatP = []
      this.backAllFlatP = []
    },
    createLensShiftP () {
      let lightCenter = this.$commonThreeD.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getAx(), this.$commonViewJs.getAy(), this.$commonViewJs.getAz()))
      let rayOrigin = this.createRay(this.selectedLensData.lcd.aspectRatio)
      // 为lensShiftRangeP赋值
      this.setAvailabelRange(rayOrigin, 'lensShiftRangeP')

      let rayLensShift = this.setRayLensShfit(rayOrigin)

      let leftTopRaycaster = new THREE.Raycaster(lightCenter, rayLensShift.LTRay)
      this.lensShiftScreenP.push(this.getBigWallIntersectPoint(leftTopRaycaster))

      let rightTopRaycaster = new THREE.Raycaster(lightCenter, rayLensShift.RTRay)
      this.lensShiftScreenP.push(this.getBigWallIntersectPoint(rightTopRaycaster))

      let rightBottomRaycaster = new THREE.Raycaster(lightCenter, rayLensShift.RBRay)
      this.lensShiftScreenP.push(this.getBigWallIntersectPoint(rightBottomRaycaster))

      let leftBottomRaycaster = new THREE.Raycaster(lightCenter, rayLensShift.LBRay)
      this.lensShiftScreenP.push(this.getBigWallIntersectPoint(leftBottomRaycaster))
      this.checkLensShiftStatus()
    },
    checkLensShiftStatus () {
      let isTouch = false
      let screenP = []
      let rangeP = []
      if (this.lensShiftRangeP.length !== 8 || this.lensShiftScreenP.length !== 4) {
        return
      }
      let param = this.isLShaped01 ? 'y' : 'z'
      for (let n = 0; n < this.lensShiftRangeP.length; n++) {
        let val = {}
        val.x = this.transTwoViewP(this.lensShiftRangeP[n]).x
        val.y = this.transTwoViewP(this.lensShiftRangeP[n])[param]
        rangeP.push(val)
      }
      for (let j = 0; j < this.lensShiftScreenP.length; j++) {
        let point = {}
        point.x = this.transTwoViewP(this.lensShiftScreenP[j]).x
        point.z = this.transTwoViewP(this.lensShiftScreenP[j])[param]
        screenP.push(point)
      }

      for (let i = 0; i < screenP.length; i++) {
        let p = {}
        let plusMinus = this.isLShaped01 ? -1 : 1
        if (i === 0) {
          p.x = screenP[i].x + this.limitData
          p.y = screenP[i].z + this.limitData * plusMinus
        } else if (i === 1) {
          p.x = screenP[i].x - this.limitData
          p.y = screenP[i].z + this.limitData * plusMinus
        } else if (i === 2) {
          p.x = screenP[i].x - this.limitData
          p.y = screenP[i].z - this.limitData * plusMinus
        } else if (i === 3) {
          p.x = screenP[i].x + this.limitData
          p.y = screenP[i].z - this.limitData * plusMinus
        }
        if (this.$commonJs.rayCasting(p, rangeP) === 'out') {
          isTouch = true
          break
        }
      }
      this.SET_ISTOUCH(isTouch)
    },
    setCenterLine () {
      let lightCenter = this.$commonThreeD.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getAx(), this.$commonViewJs.getAy(), this.$commonViewJs.getAz()))
      let vdifference, centerPDirect
      if (this.isLShaped01) {
        centerPDirect = new THREE.Vector3(0, this.position === 1 ? -1 : 1, 0)
        vdifference = this.baseLBRay.z - this.baseLTRay.z
      } else {
        centerPDirect = new THREE.Vector3(0, 0, -1)
        vdifference = this.baseLTRay.y - this.baseLBRay.y
      }

      if (this.vLensShiftNow) {
        let vData = vdifference * this.vLensShiftNow / 100
        if (this.isLShaped01) {
          centerPDirect.z += vData
        } else {
          centerPDirect.y += vData
        }
      }
      if (this.hLensShiftNow) {
        let hData = (this.baseRTRay.x - this.baseLTRay.x) * this.hLensShiftNow / 100
        centerPDirect.x += hData
      }
      let centerRaycaster = new THREE.Raycaster(lightCenter, this.setRayAngle(centerPDirect))
      this.centerCrossingP = this.getIntersectPoint(centerRaycaster)
      this.createCenterLine(lightCenter, this.centerCrossingP.value)
      this.centerLine.renderOrder = 50
      let twoDCenterP = this.transTwoViewP(this.centerCrossingP.value)
      this.SET_CENTERPOINTDATA(twoDCenterP)
    },
    setEdgeLines () {
      let lightCenter = this.$commonThreeD.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getAx(), this.$commonViewJs.getAy(), this.$commonViewJs.getAz()))
      // lightCenter.setZ(lightCenter.z + this.offsetVal)
      let rayOrigin = this.createRay(this.aspectRatio, true)
      let rayLensShift = this.setRayLensShfit(rayOrigin, true)

      this.edgePoints = []
      let leftTopRaycaster = new THREE.Raycaster(lightCenter, this.setRayAngle(rayLensShift.LTRay))
      // console.log('setEdgeLines rayLensShift', rayLensShift)
      // this.leftTopP = this.getIntersectPoint(leftTopRaycaster).value
      this.leftTopP = this.getIntersectPoint(leftTopRaycaster).value
      this.leftTopLine = this.createEdgeLine(lightCenter, this.leftTopP)

      let rightTopRaycaster = new THREE.Raycaster(lightCenter, this.setRayAngle(rayLensShift.RTRay))
      this.rightTopP = this.getIntersectPoint(rightTopRaycaster).value
      this.rightTopLine = this.createEdgeLine(lightCenter, this.rightTopP)

      let rightBottomRaycaster = new THREE.Raycaster(lightCenter, this.setRayAngle(rayLensShift.RBRay))
      this.rightBottomP = this.getIntersectPoint(rightBottomRaycaster).value
      this.rightBottomLine = this.createEdgeLine(lightCenter, this.rightBottomP)

      let leftBottomRaycaster = new THREE.Raycaster(lightCenter, this.setRayAngle(rayLensShift.LBRay))
      this.leftBottomP = this.getIntersectPoint(leftBottomRaycaster).value
      this.leftBottomLine = this.createEdgeLine(lightCenter, this.leftBottomP)
      // this.leftTopLine.material.depthTest = false
      this.leftTopLine.renderOrder = 100
      this.rightTopLine.renderOrder = 100
      this.rightBottomLine.renderOrder = 100
      this.leftBottomLine.renderOrder = 100
      this.edgePoints.push(this.leftTopP)
      this.edgePoints.push(this.rightTopP)
      this.edgePoints.push(this.rightBottomP)
      this.edgePoints.push(this.leftBottomP)
      // console.log('setEdgeLines edgePoints', JSON.stringify(this.edgePoints))
      this.setHelpLines(rayLensShift, true)
    },
    setBlackArea () {
      let lightCenter = this.$commonThreeD.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getAx(), this.$commonViewJs.getAy(), this.$commonViewJs.getAz()))
      // lightCenter.setZ(lightCenter.z + this.offsetVal)
      let rayOrigin = this.createRay(this.selectedLensData.lcd.aspectRatio)
      this.setAvailabelRange(rayOrigin)

      let rayLensShift = this.setRayLensShfit(rayOrigin)
      this.checkIsAvaInter(rayLensShift)
      // console.log('setBlackArea rayLensShift', JSON.stringify(rayLensShift))

      this.blackEdgePoints = []
      let leftTopRaycaster = new THREE.Raycaster(lightCenter, this.setRayAngle(rayLensShift.LTRay))
      this.blackLeftTopP = this.getIntersectPoint(leftTopRaycaster).value

      let rightTopRaycaster = new THREE.Raycaster(lightCenter, this.setRayAngle(rayLensShift.RTRay))
      this.blackRightTopP = this.getIntersectPoint(rightTopRaycaster).value

      let rightBottomRaycaster = new THREE.Raycaster(lightCenter, this.setRayAngle(rayLensShift.RBRay))
      this.blackRightBottomP = this.getIntersectPoint(rightBottomRaycaster).value

      let leftBottomRaycaster = new THREE.Raycaster(lightCenter, this.setRayAngle(rayLensShift.LBRay))
      this.blackLeftBottomP = this.getIntersectPoint(leftBottomRaycaster).value
      this.blackEdgePoints.push(this.blackLeftTopP)
      this.blackEdgePoints.push(this.blackRightTopP)
      this.blackEdgePoints.push(this.blackRightBottomP)
      this.blackEdgePoints.push(this.blackLeftBottomP)
      this.SET_CORNERCORAREAS([])
      this.SET_ISONCORNERAREAS(false)
      // [スクリーン位置を表示]有效的场合
      if (this.indAngleSwitch) {
        this.getCornerAreas(lightCenter, rayLensShift)
      }

      this.setHelpLines(rayLensShift)
    },
    getCornerAreas (lightCenter, rayLensShift) {
      let cornorCorAreas = []
      let isOnCornorArea = true
      // 左上区域
      let lt = rayLensShift.LTRay
      let rt = rayLensShift.RTRay
      let rb = rayLensShift.RBRay
      let lb = rayLensShift.LBRay
      let rate = this.$commonViewJs.getCornerAreaRate()
      let onPoint = lt
      const param = this.isLShaped01 ? 'z' : 'y'
      const rayCastingMethod = this.isLShaped01 ? this.$commonJs.rayCastingByxy : this.$commonJs.rayCastingByxz
      // 左上
      let xLen = (rt.x - lt.x) * rate.x
      let yLen = (lt[param] - lb[param]) * rate.y
      let xCoordinate = lt.x + xLen
      let yzCoordinate = lt[param] - yLen
      let zs = this.tbd(lightCenter, rayLensShift, onPoint, xCoordinate, yzCoordinate)
      if (rayCastingMethod(this.indAngleRemainPints[0], zs) === 'out' && isOnCornorArea) {
        isOnCornorArea = false
      }
      if (rate.y === 1) {
        if (rayCastingMethod(this.indAngleRemainPints[3], zs) === 'out' && isOnCornorArea) {
          isOnCornorArea = false
        }
      }
      cornorCorAreas.push(zs)

      // 右上
      onPoint = rt
      xLen = (rt.x - lt.x) * rate.x
      yLen = (rt[param] - rb[param]) * rate.y
      xCoordinate = rt.x - xLen
      yzCoordinate = rt[param] - yLen
      let ys = this.tbd(lightCenter, rayLensShift, onPoint, xCoordinate, yzCoordinate)
      if (rayCastingMethod(this.indAngleRemainPints[1], ys) === 'out' && isOnCornorArea) {
        isOnCornorArea = false
      }
      if (rate.y === 1) {
        if (rayCastingMethod(this.indAngleRemainPints[2], ys) === 'out' && isOnCornorArea) {
          isOnCornorArea = false
        }
      }
      cornorCorAreas.push(ys)

      // 右下
      if (rate.y === 1) {
        this.SET_ISONCORNERAREAS(isOnCornorArea)
        this.SET_CORNERCORAREAS(cornorCorAreas)
        return
      }
      onPoint = rb
      xLen = (rb.x - lb.x) * rate.x
      yLen = (rt[param] - rb[param]) * rate.y
      xCoordinate = rb.x - xLen
      yzCoordinate = rb[param] + yLen
      let yx = this.tbd(lightCenter, rayLensShift, onPoint, xCoordinate, yzCoordinate)
      if (rayCastingMethod(this.indAngleRemainPints[2], yx) === 'out' && isOnCornorArea) {
        isOnCornorArea = false
      }
      cornorCorAreas.push(yx)

      // 左下
      onPoint = lb
      xLen = (rb.x - lb.x) * rate.x
      yLen = (rt[param] - rb[param]) * rate.y
      xCoordinate = lb.x + xLen
      yzCoordinate = lb[param] + yLen
      let zx = this.tbd(lightCenter, rayLensShift, onPoint, xCoordinate, yzCoordinate)
      if (rayCastingMethod(this.indAngleRemainPints[3], zx) === 'out' && isOnCornorArea) {
        isOnCornorArea = false
      }
      cornorCorAreas.push(zx)
      this.SET_ISONCORNERAREAS(isOnCornorArea)
      this.SET_CORNERCORAREAS(cornorCorAreas)
    },
    tbd (lightCenter, rayLensShift, onPoint, xCoordinate, yzCoordinate) {
      let p0 = onPoint
      let p1, p2, p3
      if (this.isLShaped01) {
        p1 = {x: xCoordinate, y: onPoint.y, z: onPoint.z}
        p2 = {x: xCoordinate, y: onPoint.y, z: yzCoordinate}
        p3 = {x: onPoint.x, y: onPoint.y, z: yzCoordinate}
      } else {
        p1 = {x: xCoordinate, y: onPoint.y, z: onPoint.z}
        p2 = {x: xCoordinate, y: yzCoordinate, z: onPoint.z}
        p3 = {x: onPoint.x, y: yzCoordinate, z: onPoint.z}
      }
      let leftTopArea = []
      let areaP = []
      let leftTopRay = new THREE.Raycaster(lightCenter, this.setRayAngle(p0))
      let leftTopP = this.getIntersectPoint(leftTopRay, true).value

      let rightTopRay = new THREE.Raycaster(lightCenter, this.setRayAngle(p1))
      let rightTopP = this.getIntersectPoint(rightTopRay, true).value

      let rightBottomRay = new THREE.Raycaster(lightCenter, this.setRayAngle(p2))
      let rightBottomP = this.getIntersectPoint(rightBottomRay, true).value

      let leftBottomRay = new THREE.Raycaster(lightCenter, this.setRayAngle(p3))
      let leftBottomP = this.getIntersectPoint(leftBottomRay, true).value
      leftTopArea.push(leftTopP)
      leftTopArea.push(rightTopP)
      leftTopArea.push(rightBottomP)
      leftTopArea.push(leftBottomP)
      for (let i = 0; i < leftTopArea.length; i++) {
        areaP.push(this.transTwoViewP(leftTopArea[i]))
      }
      return areaP
    },
    setAvailabelRange (value, status) {
      let LTRay = value.LTRay
      let RTRay = value.RTRay
      let RBRay = value.RBRay
      let LBRay = value.LBRay
      let availP = []
      let val = 0
      let vlensMax = this.vLensShiftMax
      let vlensMin = this.vLensShiftMin

      let vdifference
      if (this.isLShaped01) {
        vdifference = this.baseLTRay.z - this.baseLBRay.z
      } else {
        vdifference = this.baseLTRay.y - this.baseLBRay.y
      }
      let vMax = vdifference * vlensMax
      let point1 = JSON.parse(JSON.stringify(LTRay))
      let point2 = JSON.parse(JSON.stringify(RTRay))
      if (this.isLShaped01) {
        point1.z += vMax
        point2.z += vMax
      } else {
        point1.y += vMax
        point2.y += vMax
      }

      let vMin = vdifference * vlensMin
      let point5 = JSON.parse(JSON.stringify(RBRay))
      let point6 = JSON.parse(JSON.stringify(LBRay))
      if (this.isLShaped01) {
        point5.z += vMin
        point6.z += vMin
      } else {
        point5.y += vMin
        point6.y += vMin
      }

      if (vlensMin > 0) {
        val = vlensMin
      }
      if (vlensMax < 0) {
        val = vlensMax
      }
      let vhMax = vdifference * (this.vhLensShiftMax + val)
      let point8 = JSON.parse(JSON.stringify(LTRay))
      let point3 = JSON.parse(JSON.stringify(RTRay))
      if (this.isLShaped01) {
        point8.z += vhMax
        point3.z += vhMax
      } else {
        point8.y += vhMax
        point3.y += vhMax
      }

      let vhMin = vdifference * (this.vhLensShiftMin + val)
      let point4 = JSON.parse(JSON.stringify(RBRay))
      let point7 = JSON.parse(JSON.stringify(LBRay))
      if (this.isLShaped01) {
        point4.z += vhMin
        point7.z += vhMin
      } else {
        point7.y += vhMin
        point4.y += vhMin
      }

      let hMax = (this.baseRTRay.x - this.baseLTRay.x) * this.hLensShiftMax
      point4.x += hMax
      point3.x += hMax

      let hMin = (this.baseRTRay.x - this.baseLTRay.x) * this.hLensShiftMin
      point7.x += hMin
      point8.x += hMin

      availP.push(point1)
      availP.push(point2)
      availP.push(point3)
      availP.push(point4)
      availP.push(point5)
      availP.push(point6)
      availP.push(point7)
      availP.push(point8)
      if (status) {
        this.getLensShiftRangeP(availP)
      } else {
        this.createAvailableRange(availP, 0)
      }
    },

    checkIsAvaInter (value) {
      let ps = []
      ps.push(JSON.parse(JSON.stringify(value.LTRay)))
      ps.push(JSON.parse(JSON.stringify(value.RTRay)))
      ps.push(JSON.parse(JSON.stringify(value.RBRay)))
      ps.push(JSON.parse(JSON.stringify(value.LBRay)))
      this.createAvailableRange(ps, 1)
    },
    getLensShiftRangeP (value) {
      if (this.selectedModelData.category === 4) {
        this.lensShiftRangeP = []
        return
      }
      let lightCenter = this.$commonThreeD.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getAx(), this.$commonViewJs.getAy(), this.$commonViewJs.getAz()))
      for (let i = 0; i < value.length; i++) {
        let ray = new THREE.Raycaster(lightCenter, value[i])
        let point = this.getBigWallIntersectPoint(ray)
        if (point) {
          this.lensShiftRangeP.push(point)
        }
      }
    },
    createAvailableRange (value, flag) {
      let lightCenter = this.$commonThreeD.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getAx(), this.$commonViewJs.getAy(), this.$commonViewJs.getAz()))
      // let availRangeGeo = new THREE.Geometry()
      // let availP = []
      let twoViewAvailP = []

      if (value) {
        for (let i = 0; i < value.length; i++) {
          let ray = new THREE.Raycaster(lightCenter, this.setRayAngle(value[i]))
          let point = this.getBigWallIntersectPoint(ray)
          if (point) {
            // availP.push(point)
            // availRangeGeo.vertices.push(point)
            twoViewAvailP.push(this.transTwoViewP(point))
          }
        }

        // availRangeGeo.vertices.push(availP[0])
        if (flag === 0) {
          // 0表示的是获取可移动区域的值的坐标
          this.avaiRange = twoViewAvailP
          this.SET_RANGEDRAWDATA(twoViewAvailP)
          // this.availableLine = this.createAvailableRangeLine(availRangeGeo)
        } else if (flag === 1) {
          this.SET_SCREEN4POINT(twoViewAvailP)
          // console.log('createAvailableRange twoViewAvailP', JSON.stringify(twoViewAvailP))
          // 勿删 锁定屏幕的左下角的点坐标，屏幕不移动
          // if (this.throw_distance_checked) {
          //   this.SET_FLTOB(this.houseInfo.roomH - this.screen4Point[3].z)
          //   this.SET_FLTOL(this.screen4Point[3].x)
          // }
        }
      }
    },
    moveScreen (twoViewAvailP, points, i) {
      let p = {}
      p.x = twoViewAvailP[i].x
      p.y = twoViewAvailP[i].z
      let line = []
      if (i === 0) {
        line.push(points[0])
        line.push(points[7])
        this.getPointOnLine(p, line)
      }
    },
    getPointOnLine (p, line) {
      if (window.direction === 'X') {
        let my = line[0].y - (line[0].x - p.x) / ((line[0].x - line[1].x) / (line[0].y - line[1].y))
        let vAngleMove = this.initScreenSize.h * this.vLensShiftNow / 100
        this.SET_VLENSSHIFT((vAngleMove - (my - p.y)) / this.initScreenSize.h * 100)
      } else {
        let mx = line[0].x - (line[0].x - line[1].x) / (line[0].y - line[1].y) * (line[0].y - p.y) + this.limitData
        let hAngleMove = this.initScreenSize.w * this.hLensShiftNow / 100
        this.SET_HLENSSHIFT((hAngleMove + (mx - p.x)) / this.initScreenSize.w * 100)
      }
    },
    createRay (ratioValue, status) {
      let ratio = ratioValue.split(':')
      let ratioW = ratio[0]
      let ratioH = ratio[1]
      let Angle
      // let dist = this.isLShaped01 ? this.graph.pjZ : this.graph.pjY
      let dist = this.$commonViewJs.getDistanceFromZorY()
      if (status) {
        Angle = this.$commonViewJs.getVerAngle(dist)
      } else {
        Angle = this.$commonViewJs.getInitVerAngle(dist)
      }
      let halfAngel = Angle / 2
      let baseX = Math.tan(halfAngel * Math.PI / 180)
      let baseY, baseZ
      // L字投影 桌面:向上，吊顶:向下
      if (this.isLShaped01) {
        baseY = this.position === 1 ? -1 : 1
        baseZ = baseX * ratioH / ratioW
      } else {
        baseY = baseX * ratioH / ratioW
        baseZ = -1
      }

      let LTRay, RTRay, RBRay, LBRay
      if (this.isLShaped01) {
        LTRay = new THREE.Vector3(-baseX, baseY, baseZ)
        RTRay = new THREE.Vector3(baseX, baseY, baseZ)
        RBRay = new THREE.Vector3(baseX, baseY, -baseZ)
        LBRay = new THREE.Vector3(-baseX, baseY, -baseZ)
      } else {
        LTRay = new THREE.Vector3(-baseX, baseY, baseZ)
        RTRay = new THREE.Vector3(baseX, baseY, baseZ)
        RBRay = new THREE.Vector3(baseX, -baseY, baseZ)
        LBRay = new THREE.Vector3(-baseX, -baseY, baseZ)
      }

      if (!status) {
        this.baseLTRay = LTRay
        this.baseRTRay = RTRay
        this.baseRBRay = RBRay
        this.baseLBRay = LBRay
      }
      // console.log('createRay', 'baseLTRay', this.baseLTRay, 'baseRTRay', this.baseRTRay, 'baseRBRay', this.baseRBRay, 'baseLBRay', this.baseLBRay)
      return {'LTRay': LTRay, 'RTRay': RTRay, 'RBRay': RBRay, 'LBRay': LBRay}
    },
    setRayLensShfit (value, state) {
      // add lensshift
      let LTRay = value.LTRay
      let RTRay = value.RTRay
      let RBRay = value.RBRay
      let LBRay = value.LBRay

      let vVal = this.vLensShiftNow
      // console.log('vLensShiftNow vVal', vVal)

      if ((this.selectedModelData.category === this.$constant.PROJECTSPEC_CATEGORY_UST || (this.selectedModelData.category === this.$constant.PROJECTSPEC_CATEGORY_HOME && this.selectedModelData.type === this.$constant.PROJECTSPEC_TYPE_UST)) && !this.screenSizeChecked && !this.throwDistanceChecked) {
        let flag = 1
        if (this.position !== 0) {
          flag = -1
        }
        let distInfo = this.$commonJs.findSpecInfoByRatio(this.aspectRatio, this.selectedLensData)

        // let v1a = this.screenSize * distInfo.v1b.w.a
        // let res = (this.graph.scrnH / 2 + v1a) / this.initScreenSize.h
        let v1b = this.screenSize * distInfo.v1b.w.a + distInfo.v1b.w.b
        let res = (this.graph.scrnH / 2 + v1b - this.selectedLensData.mu) / this.initScreenSize.h
        vVal = res * flag * 100
        // console.log('~~~~~~~~~~~~~~~~~~~~~')
        // console.log(vVal)
        let va = {}
        this.SET_VLENSSHIFT(vVal)
        va.max = res
        va.min = res
        this.SET_TEMVLENSSHIFT(va)
      }
      if (state && this.isUSTWall && this.USTLenshiftV) {
        vVal = this.USTLenshiftV
      }
      // console.log('vLensShiftNow', vVal)
      if (vVal) {
        let vData
        if (this.isLShaped01) {
          vData = (this.baseLBRay.z - this.baseLTRay.z) * vVal / 100
          LTRay.z += vData
          RTRay.z += vData
          RBRay.z += vData
          LBRay.z += vData
        } else {
          vData = (this.baseLTRay.y - this.baseLBRay.y) * vVal / 100
          LTRay.y += vData
          RTRay.y += vData
          RBRay.y += vData
          LBRay.y += vData
        }
      }
      // console.log('this.hLensShiftNow', this.hLensShiftNow)
      if (this.hLensShiftNow) {
        let hData = (this.baseRTRay.x - this.baseLTRay.x) * this.hLensShiftNow / 100
        LTRay.x += hData
        RTRay.x += hData
        RBRay.x += hData
        LBRay.x += hData
      }
      // console.log('setRayLensShfit', 'LTRay', LTRay, 'RTRay', RTRay, 'RBRay', RBRay, 'LBRay', LBRay)
      return {LTRay, RTRay, RBRay, LBRay}
    },
    setRayAngle (ray) {
      let xBaseVector = new THREE.Vector3(1, 0, 0)
      let vRotate = this.isUSTWall ? 0 : this.vAngle * Math.PI / 180
      let hRotate = this.isUSTWall ? 0 : this.isLShaped01 ? this.hAngle * (-1) * Math.PI / 180 : this.hAngle * Math.PI / 180

      let yBaseVector = new THREE.Vector3(0, -1, 0)
      let zBaseVector = new THREE.Vector3(0, 0, this.position === 1 ? -1 : 1)
      let hBaseVector = this.isLShaped01 ? zBaseVector : yBaseVector
      let rayDirect
      if (ray) {
        rayDirect = new THREE.Vector3(ray.x, ray.y, ray.z).normalize()
      }
      if (this.vAngle && this.vAngleFlag) {
        rayDirect.applyAxisAngle(xBaseVector, vRotate)
      }
      if (this.hAngle && this.hAngleFlag) {
        rayDirect.applyAxisAngle(hBaseVector, hRotate)
      }
      return rayDirect
    },
    setHelpLines (value, status) { // !status blackarea
      let topLineP = []
      let leftLineP = []
      let bottomLineP = []
      let rightLineP = []

      let drawTopLineP = []
      let drawLeftLineP = []
      let drawBottomLineP = []
      let drawRightLineP = []

      let LTRay = value.LTRay
      let RTRay = value.RTRay
      let RBRay = value.RBRay
      let LBRay = value.LBRay

      let divide = null
      if (this.browserType !== 'ie') {
        divide = 50
      } else {
        divide = 20
      }

      let lightCenter = this.$commonThreeD.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getAx(), this.$commonViewJs.getAy(), this.$commonViewJs.getAz()))
      // lightCenter.setZ(lightCenter.z + this.offsetVal)
      let helpLineGeo = new THREE.Geometry()
      let xBaseVector = new THREE.Vector3(1, 0, 0)
      let vRotate = this.vAngleFlag ? this.vAngle * Math.PI / 180 : 0
      let yBaseVector = new THREE.Vector3(0, -1, 0)
      let zBaseVector = new THREE.Vector3(0, 0, this.position === 1 ? -1 : 1)
      let hBaseVector = this.isLShaped01 ? zBaseVector : yBaseVector
      let hRotate = this.hAngleFlag ? this.isLShaped01 ? this.hAngle * (-1) * Math.PI / 180 : this.hAngle * Math.PI / 180 : 0

      // console.log('setHelpLines start 1111111111111111111')
      // let topLineDensity = (RTRay.x - LTRay.x) / divide
      let intersectionPoint = null
      let backPosition = ''
      let pointX = this.splitPointsXorY(LTRay.x, RTRay.x, divide)
      for (let i = 0; i < pointX.length; i++) {
        let topLineVector = new THREE.Vector3(pointX[i], LTRay.y, LTRay.z)
        let topHelpLineDirection = topLineVector.normalize()
        topHelpLineDirection.applyAxisAngle(xBaseVector, vRotate)
        topHelpLineDirection.applyAxisAngle(hBaseVector, hRotate)
        let ray = new THREE.Raycaster(lightCenter, topHelpLineDirection)
        let point = this.getIntersectPoint(ray)
        // console.log('point.position top', point.position, i, drawTopLineP.length)
        // console.log('point.position top', JSON.stringify(point))
        if (i === 0) backPosition = point.position
        if (backPosition !== point.position && this.isCurvedWallDisplay) {
          // console.log('point.position top', backPosition, point.position, i)
          let pointRay = {x: pointX[i - 1], y: LTRay.y, z: LTRay.z}
          intersectionPoint = this.setDivisionPoint(pointRay, pointX[i], 50, xBaseVector, vRotate, hBaseVector, hRotate, lightCenter, 'x', backPosition)
          // 从左边开始第一个 无交点 -> 有交点 的场合(保存第一个交点)
          if (point.position !== 'center') {
            drawTopLineP.push(intersectionPoint)
            drawTopLineP.push(point.value)
            helpLineGeo.vertices.push(intersectionPoint)
          } else {
            // 从左边开始第一个 有交点 -> 无交点 的场合(保存最后一个交点)
            drawTopLineP.push(intersectionPoint)
            helpLineGeo.vertices.push(intersectionPoint)
            break
          }
          backPosition = point.position
        } else {
          if (point.position !== 'center') {
            drawTopLineP.push(point.value)
          }
        }
        this.setFlatPoint(point, status)
        topLineP.push(point.value)
        helpLineGeo.vertices.push(point.value)
        // console.log('topLineP', JSON.stringify(point))
      }
      // console.log('drawTopLineP', JSON.stringify(drawTopLineP))

      // let rightLineDensity = (RBRay.y - RTRay.y) / divide
      intersectionPoint = null
      backPosition = ''
      let param = this.isLShaped01 ? 'z' : 'y'
      let pointYZ = this.splitPointsXorY(RTRay[param], RBRay[param], divide)
      for (let i = 0; i < pointYZ.length; i++) {
        let rightLineVector = this.isLShaped01 ? new THREE.Vector3(RTRay.x, RTRay.y, pointYZ[i]) : new THREE.Vector3(RTRay.x, pointYZ[i], RTRay.z)
        let rightHelpLineDirection = rightLineVector.normalize()
        rightHelpLineDirection.applyAxisAngle(xBaseVector, vRotate)
        rightHelpLineDirection.applyAxisAngle(hBaseVector, hRotate)
        let ray = new THREE.Raycaster(lightCenter, rightHelpLineDirection)
        let point = this.getIntersectPoint(ray)
        // console.log('point.position right', point.position, i, drawRightLineP.length)
        // console.log('point.position right', JSON.stringify(point))
        if (i === 0) backPosition = point.position
        if (backPosition !== point.position && this.isCurvedWallDisplay) {
          // console.log('point.position right', backPosition, point.position, i, RTRay.y + (rightLineDensity * i))
          let pointRay = this.isLShaped01 ? {x: RTRay.x, y: RTRay.y, z: pointYZ[i - 1]} : {x: RTRay.x, y: pointYZ[i - 1], z: RTRay.z}
          intersectionPoint = this.setDivisionPoint(pointRay, pointYZ[i], 50, xBaseVector, vRotate, hBaseVector, hRotate, lightCenter, param, backPosition)
          // 从上边开始 无交点 -> 有交点 的场合(保存第一个交点)
          if (point.position !== 'center') {
            drawRightLineP.push(intersectionPoint)
            drawRightLineP.push(point.value)
            helpLineGeo.vertices.push(intersectionPoint)
          } else {
            // 从上边开始 有交点 -> 无交点 的场合(保存最后一个交点)
            drawRightLineP.push(intersectionPoint)
            helpLineGeo.vertices.push(intersectionPoint)
            break
          }
          backPosition = point.position
        } else {
          if (point.position !== 'center') {
            drawRightLineP.push(point.value)
          }
        }
        this.setFlatPoint(point, status)
        rightLineP.push(point.value)
        helpLineGeo.vertices.push(point.value)
        // console.log('rightLineP', JSON.stringify(point))
      }

      // let bottomLineDensity = (LBRay.x - RBRay.x) / divide
      intersectionPoint = null
      backPosition = ''
      pointX = this.splitPointsXorY(RBRay.x, LBRay.x, divide)
      for (let i = 0; i < pointX.length; i++) {
        let bottomLineVector = new THREE.Vector3(pointX[i], RBRay.y, RBRay.z)
        let bottomHelpLineDirection = bottomLineVector.normalize()
        bottomHelpLineDirection.applyAxisAngle(xBaseVector, vRotate)
        bottomHelpLineDirection.applyAxisAngle(hBaseVector, hRotate)
        let ray = new THREE.Raycaster(lightCenter, bottomHelpLineDirection)
        let point = this.getIntersectPoint(ray)
        // console.log('point.position bottom', JSON.stringify(point))
        if (i === 0) backPosition = point.position
        if (backPosition !== point.position && this.isCurvedWallDisplay) {
          // console.log('point.position bottom', backPosition, point.position, i, RBRay.x + (bottomLineDensity * i))
          let pointRay = {x: pointX[i - 1], y: RBRay.y, z: RBRay.z}
          intersectionPoint = this.setDivisionPoint(pointRay, pointX[i], 50, xBaseVector, vRotate, hBaseVector, hRotate, lightCenter, 'x', backPosition)
          // 从右边开始 无交点 -> 有交点 的场合(保存第一个交点)
          if (point.position !== 'center') {
            drawBottomLineP.push(intersectionPoint)
            drawBottomLineP.push(point.value)
            helpLineGeo.vertices.push(intersectionPoint)
          } else {
            // 从右边开始 有交点 -> 无交点 的场合(保存最后一个交点)
            drawBottomLineP.push(intersectionPoint)
            helpLineGeo.vertices.push(intersectionPoint)
            break
          }
          backPosition = point.position
        } else {
          if (point.position !== 'center') {
            drawBottomLineP.push(point.value)
          }
        }
        this.setFlatPoint(point, status)
        bottomLineP.push(point.value)
        helpLineGeo.vertices.push(point.value)
        // console.log('bottomLineP', JSON.stringify(point))
      }

      // let leftLineDensity = (LTRay.y - LBRay.y) / divide
      intersectionPoint = null
      backPosition = ''
      pointYZ = this.splitPointsXorY(LBRay[param], LTRay[param], divide)
      for (let i = 0; i < pointYZ.length; i++) {
        let leftLineVector = this.isLShaped01 ? new THREE.Vector3(LBRay.x, LBRay.y, pointYZ[i]) : new THREE.Vector3(LBRay.x, pointYZ[i], LBRay.z)
        let leftHelpLineDirection = leftLineVector.normalize()
        leftHelpLineDirection.applyAxisAngle(xBaseVector, vRotate)
        leftHelpLineDirection.applyAxisAngle(hBaseVector, hRotate)
        let ray = new THREE.Raycaster(lightCenter, leftHelpLineDirection)
        let point = this.getIntersectPoint(ray)
        // console.log('point.position left', JSON.stringify(point))
        if (i === 0) backPosition = point.position
        if (backPosition !== point.position && this.isCurvedWallDisplay) {
          // console.log('point.position left', backPosition, point.position, i, LBRay.y + (leftLineDensity * i))
          let pointRay = this.isLShaped01 ? {x: LBRay.x, y: LBRay.y, z: pointYZ[i - 1]} : {x: LBRay.x, y: pointYZ[i - 1], z: LBRay.z}
          intersectionPoint = this.setDivisionPoint(pointRay, pointYZ[i], 50, xBaseVector, vRotate, hBaseVector, hRotate, lightCenter, param, backPosition)
          // 从下边开始 无交点 -> 有交点 的场合(保存第一个交点)
          if (point.position !== 'center') {
            drawLeftLineP.push(intersectionPoint)
            drawLeftLineP.push(point.value)
            helpLineGeo.vertices.push(intersectionPoint)
          } else {
            // 从下边开始 有交点 -> 无交点 的场合(保存最后一个交点)
            drawLeftLineP.push(intersectionPoint)
            helpLineGeo.vertices.push(intersectionPoint)
            break
          }
          backPosition = point.position
        } else {
          if (point.position !== 'center') {
            drawLeftLineP.push(point.value)
          }
        }
        this.setFlatPoint(point, status)
        leftLineP.push(point.value)
        helpLineGeo.vertices.push(point.value)
        // console.log('leftLineP', JSON.stringify(point))
      }
      helpLineGeo.vertices.push(topLineP[0])
      if (this.isCurvedWallDisplay) {
        this.frontFlatP = [...drawTopLineP, ...drawRightLineP, ...drawBottomLineP, ...drawLeftLineP]
      }

      // console.log('setHelpLines end 2222222222222222222222222222')
      if (status) {
        let helpLineP = []
        helpLineP.push(this.edgePoints)
        helpLineP.push(topLineP)
        helpLineP.push(rightLineP)
        helpLineP.push(bottomLineP)
        helpLineP.push(leftLineP)
        // console.log('helpLineP', helpLineP)

        let drawLineP = []
        drawLineP.push(this.edgePoints)
        drawLineP.push(drawTopLineP)
        drawLineP.push(drawRightLineP)
        drawLineP.push(drawBottomLineP)
        drawLineP.push(drawLeftLineP)

        let tmpEdgePoints = []
        if ((drawRightLineP.length === 0 || drawLeftLineP.length === 0) && (drawTopLineP.length !== 0 && drawBottomLineP.length !== 0)) {
          tmpEdgePoints.push(drawTopLineP[0], drawTopLineP[drawTopLineP.length - 1])
          tmpEdgePoints.push(drawBottomLineP[0], drawBottomLineP[drawBottomLineP.length - 1])
          drawLineP[0] = tmpEdgePoints
        }
        if ((drawRightLineP.length !== 0 && drawLeftLineP.length !== 0) && (drawTopLineP.length === 0 || drawBottomLineP.length === 0)) {
          tmpEdgePoints.push(drawRightLineP[0], drawRightLineP[drawRightLineP.length - 1])
          tmpEdgePoints.push(drawLeftLineP[0], drawLeftLineP[drawLeftLineP.length - 1])
          drawLineP[0] = tmpEdgePoints
        }

        this.helpLine = this.createHelpLine(helpLineGeo)
        this.helpLine.renderOrder = 80
        // this.helpLine.material.depthTest = false
        let drawData = this.setDrawData(drawLineP)
        this.dashDatas = helpLineP
        let offSet = this.limitData + this.offset + (this.curveDirection === '1' ? this.curveDepth : 0)
        let touchP = drawData[0].find(
          item => (!this.isLShaped01 && item.y > offSet) || (this.isLShaped01 && this.position === 0 && item.z > offSet) || (this.isLShaped01 && this.position === 1 && item.z < (this.houseInfo.roomH - offSet))
        )
        if (touchP === '' || touchP === undefined) {
          this.SET_TOUCHWALLFLAG(false)
        } else {
          this.SET_TOUCHWALLFLAG(true)
        }

        // console.log('drawData[0]', JSON.stringify(drawData[0]))
        this.SET_DRAWDATA(drawData)
      } else {
        let blackHelpLineP = []
        blackHelpLineP.push(this.blackEdgePoints)
        blackHelpLineP.push(drawTopLineP)
        blackHelpLineP.push(drawRightLineP)
        blackHelpLineP.push(drawBottomLineP)
        blackHelpLineP.push(drawLeftLineP)

        // this.blackHelpLine = this.createblackHelpLine(helpLineGeo)
        // this.blackHelpLine.renderOrder = 2
        let blackDrawData = this.setDrawData(blackHelpLineP)
        this.SET_BLACKDRAWDATA(blackDrawData)
      }
    },
    splitPointsXorY (start, end, step) {
      const points = []
      for (let i = 0; i <= step; i++) {
        // 计算插值比例
        const t = i / step
        // 线性插值计算坐标
        const xory = start + (end - start) * t
        points.push(xory)
      }
      return points
    },
    setDivisionPoint (pointRay, currentXYZ, divide, xBaseVector, vRotate, hBaseVector, hRotate, lightCenter, XYZ, backPosition) {
      let result = {}
      let pointsXYZ = this.splitPointsXorY(pointRay[XYZ], currentXYZ, divide)
      // let lineDensity = density / divide
      for (let i = 0; i < pointsXYZ.length; i++) {
        // if (i === 0) {
        //   console.log('setDivisionPoint', i, pointRay.x + (lineDensity * i))
        // }
        let lineVector
        if (XYZ === 'x') {
          lineVector = new THREE.Vector3(pointsXYZ[i], pointRay.y, pointRay.z)
        } else if (XYZ === 'y') {
          lineVector = new THREE.Vector3(pointRay.x, pointsXYZ[i], pointRay.z)
        } else {
          lineVector = new THREE.Vector3(pointRay.x, pointRay.y, pointsXYZ[i])
        }
        let lineDirection = lineVector.normalize()
        lineDirection.applyAxisAngle(xBaseVector, vRotate)
        lineDirection.applyAxisAngle(hBaseVector, hRotate)
        let ray = new THREE.Raycaster(lightCenter, lineDirection)
        let point = this.getIntersectPoint(ray)
        if (point.position !== 'center') {
          // result.push(point.value)
          result = point.value
          // console.log('setDivisionPoint 11111', JSON.stringify(point))
        }
        if (backPosition !== point.position) {
          // console.log('setDivisionPoint', i, pointRay.x + (lineDensity * i))
          // console.log('setDivisionPoint 2221', JSON.stringify(point), backPosition)
          break
        }
      }
      return result
    },
    setDashLines () {
      if (this.dashFlag) {
        let helpLineGeos = new THREE.Geometry()
        let dashDataStor = []
        for (let i = 0; i < this.dashDataRemain.length; i++) {
          let dashDataStorL = []
          for (let j = 0; j < this.dashDataRemain[i].length; j++) {
            if (i !== 0) {
              helpLineGeos.vertices.push(this.dashDataRemain[i][j])
            }
            dashDataStorL.push(this.dashDataRemain[i][j])
          }
          dashDataStor.push(dashDataStorL)
        }
        helpLineGeos.vertices.push(this.dashDataRemain[1][0])
        this.dashLine = this.createDashLine(helpLineGeos)
        this.dashLine.renderOrder = 80
        let dashDataStore = this.setDrawData(dashDataStor)
        this.SET_DASHDATA(dashDataStore)
      }
    },
    setFlatPoint (point, status) {
      if (point.position && status) {
        // if (point.position !== 'center') this.allPoints.push(point.value)
        if (this.isLShaped01) {
          // this.allPoints.push(point)
          if (point.position !== 'back') this.frontAllFlatP.push(point.value)
          if (point.position !== 'left') this.rightAllFlatP.push(point.value)
          if (point.position !== 'right') this.leftAllFlatP.push(point.value)
          if (point.position !== 'bottom') this.topAllFlatP.push(point.value)
          if (point.position !== 'top') this.bottomAllFlatP.push(point.value)
          if (point.position !== 'front') this.backAllFlatP.push(point.value)
        }
        this.allPoints.push(point.value)
        switch (point.position) {
          case 'front':
            this.frontFlatP.push(point.value)
            break
          case 'right':
            this.rightFlatP.push(point.value)
            break
          case 'left':
            this.leftFlatP.push(point.value)
            break
          case 'top':
            this.topFlatP.push(point.value)
            break
          case 'bottom':
            this.bottomFlatP.push(point.value)
            break
          case 'back':
            this.backFlatP.push(point.value)
            break
          default:
            break
        }
      }
    },
    initFlatColor () {
      if (this.allPoints.length === 0) return
      if (this.isLShaped01) {
        this.initFlatColorLShaped()
        return
      }

      let rLen = this.rightFlatP.length
      let lLen = this.leftFlatP.length
      let tLen = this.topFlatP.length
      let bLen = this.bottomFlatP.length
      let point = this.getRoomCubePoint()
      // 投影的区域（浅黄色部分）
      var material = new THREE.MeshBasicMaterial({ color: 0xfbfcb5, opacity: 0.85, side: THREE.DoubleSide, transparent: true })
      if (this.isCurvedWallDisplay && this.curveCentralAngle) {
        this.curveWallPaint()
      } else {
        let pointData = this.isCurvedWallDisplay ? this.frontFlatP : this.allPoints
        if (pointData.length > 0) {
          let wallOffsetTemp = this.wallOffset
          // 透明物体的渲染顺序 和 深度写入（Depth Write） 的冲突，导致部分物体不显示(透过黄色投影，看到的 绿色屏幕不完整)
          if (this.isCurvedWallDisplay) {
            wallOffsetTemp = this.wallOffset + 0.05
            material = new THREE.MeshBasicMaterial({ color: 0xfbfcb5, opacity: 0.8, side: THREE.DoubleSide, transparent: true, depthWrite: false })
          }
          var frontShape = new THREE.Shape()
          frontShape.moveTo(pointData[0].x, pointData[0].y)
          for (let i = 1; i < pointData.length; i++) {
            frontShape.lineTo(pointData[i].x, pointData[i].y)
          }
          var frontGeo = new THREE.ShapeGeometry(frontShape)
          this.frontMesh = new THREE.Mesh(frontGeo, material)
          this.frontMesh.position.setZ(point.b2.z + this.offsetVal + wallOffsetTemp)
          if (this.isCurvedWallDisplay) {
            this.frontMesh.renderOrder = 1
          }
          if (this.browserType !== 'ie') {
            this.addToScene(this.frontMesh)
          }
        }
      }

      if (this.isOutOfSpec) {
        return
      }
      // if (!this.offsetVal) {
      if (rLen || lLen) {
        var sideShape = new THREE.Shape()
        sideShape.moveTo(this.allPoints[0].y, this.allPoints[0].z)
        for (let i = 1; i < this.allPoints.length; i++) {
          sideShape.lineTo(this.allPoints[i].y, this.allPoints[i].z)
        }
        var sideGeo = new THREE.ShapeGeometry(sideShape)
        this.sideMesh = new THREE.Mesh(sideGeo, material)
        this.sideMesh.rotation.y = Math.PI / 2
        this.sideMesh.rotation.z = Math.PI / 2
        if (lLen) {
          this.sideMesh.position.setX(point.b1.x + this.wallOffset)
        } else {
          this.sideMesh.position.setX(point.b2.x - this.wallOffset)
        }
        if (this.browserType !== 'ie') {
          this.addToScene(this.sideMesh)
        }
      }

      if (tLen || bLen) {
        var topShape = new THREE.Shape()
        topShape.moveTo(this.allPoints[0].x, this.allPoints[0].z)
        for (let i = 1; i < this.allPoints.length; i++) {
          topShape.lineTo(this.allPoints[i].x, this.allPoints[i].z)
        }
        var topGeo = new THREE.ShapeGeometry(topShape)
        this.topMesh = new THREE.Mesh(topGeo, material)
        this.topMesh.rotation.x = Math.PI / 2
        if (tLen) {
          this.topMesh.position.setY(point.b1.y)
        } else {
          this.topMesh.position.setY(point.c1.y + this.wallOffset)
        }
        if (this.browserType !== 'ie') {
          this.addToScene(this.topMesh)
        }
      }
      // }
    },
    /**
     * 计算与指定方向相交的墙壁数量
     * @param {string} direction - 观察方向 ('front' | 'back' | 'left' | 'right' | 'top' | 'bottom')
     * @returns {number} 相交的墙壁数量
     */
    getNumberOfIntersectingWalls (direction) {
      let num = 0
      // 根据观察方向判断可见的墙面，相反方向的墙面会被遮挡
      if (this.frontFlatP.length > 0 && (direction !== 'back' || !direction)) num++
      if (this.backFlatP.length > 0 && (direction !== 'front' || !direction)) num++
      if (this.leftFlatP.length > 0 && (direction !== 'right' || !direction)) num++
      if (this.rightFlatP.length > 0 && (direction !== 'left' || !direction)) num++
      if (this.topFlatP.length > 0 && (direction !== 'bottom' || !direction)) num++
      if (this.bottomFlatP.length > 0 && (direction !== 'top' || !direction)) num++
      return num
    },
    initFlatColorLShaped () {
      if (this.browserType === 'ie') return
      if (this.allPoints.length === 0) return
      // console.log('allPoints', this.allPoints.length)
      // console.log('frontAllFlatP', this.frontAllFlatP.length, 'backAllFlatP', this.backAllFlatP.length)
      // console.log('leftAllFlatP', this.leftAllFlatP.length, 'rightAllFlatP', this.rightAllFlatP.length)
      // console.log('topAllFlatP', this.topAllFlatP.length, 'bottomAllFlatP', this.bottomAllFlatP.length)

      // console.log('======================================')
      // console.log('frontFlatP', this.frontFlatP.length, 'backFlatP', this.backFlatP.length)
      // console.log('leftFlatP', this.leftFlatP.length, 'rightFlatP', this.rightFlatP.length)
      // console.log('topFlatP', this.topFlatP.length, 'bottomFlatP', this.bottomFlatP.length)

      let intersectingWallNum = this.getNumberOfIntersectingWalls()
      // console.log('intersecting Wall Num', intersectingWallNum)
      if (intersectingWallNum <= 3) {
        this.initFlatColorLShapedFor3Walls()
      } else {
        this.initFlatColorLShapedFor4Walls()
      }
    },
    initFlatColorLShapedFor3Walls () {
      let rLen = this.rightFlatP.length
      let lLen = this.leftFlatP.length
      let tLen = this.topFlatP.length
      let bLen = this.bottomFlatP.length
      let fLen = this.frontFlatP.length
      let baLen = this.backFlatP.length
      let point = this.getRoomCubePoint()
      // let pointData
      // 投影的区域（浅黄色部分）
      var material = new THREE.MeshBasicMaterial({ color: 0xfbfcb5, opacity: 0.85, side: THREE.DoubleSide, transparent: true })
      const _createFaceMesh = (pointData, x, y) => {
        var shape = new THREE.Shape()
        shape.moveTo(pointData[0][x], pointData[0][y])
        for (let i = 1; i < pointData.length; i++) {
          shape.lineTo(pointData[i][x], pointData[i][y])
        }
        var geometry = new THREE.ShapeGeometry(shape)
        return new THREE.Mesh(geometry, material)
      }

      if (fLen > 0 && !this.isOutOfSpec) {
        // pointData = this.frontFlatP
        // pointData = this.allPoints.filter(item => item.position !== 'back').map(item => item.value)
        // pointData = this.frontAllFlatP
        this.frontMesh = _createFaceMesh(this.frontAllFlatP, 'x', 'y')
        this.frontMesh.position.setZ(point.b2.z + this.wallOffset)
        this.addToScene(this.frontMesh)
      }

      if (baLen > 0 && !this.isOutOfSpec) {
        // material = new THREE.MeshBasicMaterial({ color: 0x000, opacity: 0.85, side: THREE.DoubleSide, transparent: true })
        // pointData = this.backFlatP
        // pointData = this.allPoints.filter(item => item.position !== 'front').map(item => item.value)
        // pointData = this.backAllFlatP
        this.backMesh = _createFaceMesh(this.backAllFlatP, 'x', 'y')
        this.backMesh.position.setZ(-point.b2.z - this.wallOffset)
        this.addToScene(this.backMesh)
      }

      if (lLen > 0 && !this.isOutOfSpec) {
        // material = new THREE.MeshBasicMaterial({ color: 0xff000, opacity: 0.85, side: THREE.DoubleSide, transparent: true })
        // pointData = this.leftFlatP
        // pointData = this.allPoints.filter(item => item.position !== 'right').map(item => item.value)
        // pointData = this.leftAllFlatP
        this.leftMesh = _createFaceMesh(this.leftAllFlatP, 'y', 'z')
        this.leftMesh.rotation.y = Math.PI / 2
        this.leftMesh.rotation.z = Math.PI / 2
        this.leftMesh.position.setX(point.b1.x + this.wallOffset)
        this.addToScene(this.leftMesh)
      }

      if (rLen > 0 && !this.isOutOfSpec) {
        // material = new THREE.MeshBasicMaterial({ color: 0xffff00, opacity: 0.85, side: THREE.DoubleSide, transparent: true })
        // pointData = this.rightFlatP
        // pointData = this.allPoints.filter(item => item.position !== 'left').map(item => item.value)
        // pointData = this.rightAllFlatP
        this.sideMesh = _createFaceMesh(this.rightAllFlatP, 'y', 'z')
        this.sideMesh.rotation.y = Math.PI / 2
        this.sideMesh.rotation.z = Math.PI / 2
        this.sideMesh.position.setX(point.b2.x - this.wallOffset)
        this.addToScene(this.sideMesh)
      }

      if (tLen || (this.isOutOfSpec && this.position === 0)) {
        // material = new THREE.MeshBasicMaterial({ color: 0x00ff00, opacity: 0.85, side: THREE.DoubleSide, transparent: true })
        // pointData = this.topFlatP
        // pointData = this.allPoints.filter(item => item.position !== 'bottom').map(item => item.value)
        // pointData = this.topAllFlatP
        this.topMesh = _createFaceMesh(this.topAllFlatP, 'x', 'z')
        this.topMesh.rotation.x = Math.PI / 2
        this.topMesh.position.setY(point.b1.y - this.offsetVal - this.wallOffset)
        this.addToScene(this.topMesh)
      }

      if (bLen || (this.isOutOfSpec && this.position === 1)) {
        // material = new THREE.MeshBasicMaterial({ color: 0x00ffff, opacity: 0.85, side: THREE.DoubleSide, transparent: true })
        // pointData = this.bottomFlatP
        // pointData = this.allPoints.filter(item => item.position !== 'top').map(item => item.value)
        // pointData = this.bottomAllFlatP
        this.bottomMesh = _createFaceMesh(this.bottomAllFlatP, 'x', 'z')
        this.bottomMesh.rotation.x = Math.PI / 2
        this.bottomMesh.position.setY(point.c1.y + this.offsetVal + this.wallOffset)
        this.addToScene(this.bottomMesh)
      }
    },
    /**
     * 获取各个面的坐标最大最小值
     * @returns {Object} 包含各面坐标范围的对象
     */
    getObjMinMax (points, axes) {
      const result = {}
      axes.forEach(axis => {
        if (points.length === 0) {
          result[axis] = { min: null, max: null }
          return
        }
        const values = points.map(p => p[axis])
        result[axis] = {
          min: Math.min(...values),
          max: Math.max(...values)
        }
      })
      return result
    },
    getFlatPointsBounds () {
      return {
        front: this.getObjMinMax(this.frontFlatP, ['x', 'y']),
        back: this.getObjMinMax(this.backFlatP, ['x', 'y']),
        left: this.getObjMinMax(this.leftFlatP, ['y', 'z']),
        right: this.getObjMinMax(this.rightFlatP, ['y', 'z']),
        top: this.getObjMinMax(this.topFlatP, ['x', 'z']),
        bottom: this.getObjMinMax(this.bottomFlatP, ['x', 'z'])
      }
    },
    getFlatAllPointsBounds () {
      return {
        front: this.getObjMinMax(this.frontAllFlatP, ['x', 'y']),
        back: this.getObjMinMax(this.backAllFlatP, ['x', 'y']),
        left: this.getObjMinMax(this.leftAllFlatP, ['y', 'z']),
        right: this.getObjMinMax(this.rightAllFlatP, ['y', 'z']),
        top: this.getObjMinMax(this.topAllFlatP, ['x', 'z']),
        bottom: this.getObjMinMax(this.bottomAllFlatP, ['x', 'z'])
      }
    },
    initFlatColorLShapedFor4Walls () {
      let rLen = this.rightFlatP.length
      let lLen = this.leftFlatP.length
      // let tLen = this.topFlatP.length
      // let bLen = this.bottomFlatP.length
      let fLen = this.frontFlatP.length
      let baLen = this.backFlatP.length
      let point = this.getRoomCubePoint()
      // 投影的区域（浅黄色部分）
      var material = new THREE.MeshBasicMaterial({ color: 0xfbfcb5, opacity: 0.85, side: THREE.DoubleSide, transparent: true })
      const _createFaceMesh = (pointData, x, y) => {
        var shape = new THREE.Shape()
        shape.moveTo(pointData[0][x], pointData[0][y])
        for (let i = 1; i < pointData.length; i++) {
          shape.lineTo(pointData[i][x], pointData[i][y])
        }
        var geometry = new THREE.ShapeGeometry(shape)
        return new THREE.Mesh(geometry, material)
      }

      let pointData = this.allPoints
      if (pointData.length > 0) {
        if (this.position === 0) {
          this.topMesh = _createFaceMesh(this.topAllFlatP, 'x', 'z')
          this.topMesh.rotation.x = Math.PI / 2
          this.topMesh.position.setY(point.b1.y - this.offsetVal - this.wallOffset)
          this.addToScene(this.topMesh)
        } else {
          this.bottomMesh = _createFaceMesh(this.bottomAllFlatP, 'x', 'z')
          this.bottomMesh.rotation.x = Math.PI / 2
          this.bottomMesh.position.setY(point.c1.y + this.offsetVal + this.wallOffset)
          this.addToScene(this.bottomMesh)
        }
      }

      if (this.isOutOfSpec) {
        return
      }

      if (rLen || lLen) {
        this.sideMesh = _createFaceMesh(this.allPoints, 'y', 'z')
        this.sideMesh.rotation.y = Math.PI / 2
        this.sideMesh.rotation.z = Math.PI / 2
        if (lLen) {
          this.sideMesh.position.setX(point.b1.x + this.wallOffset)
        } else {
          this.sideMesh.position.setX(point.b2.x - this.wallOffset)
        }
        this.addToScene(this.sideMesh)
      }

      if (fLen || baLen) {
        this.frontMesh = _createFaceMesh(this.allPoints, 'x', 'y')
        this.frontMesh.position.setZ(point.b2.z + this.wallOffset)
        if (fLen) {
          this.frontMesh.position.setZ(point.b2.z + this.wallOffset)
        } else {
          this.frontMesh.position.setZ(-point.b2.z - this.wallOffset)
        }
        this.addToScene(this.frontMesh)
      }

      // if (!fLen && !baLen && rLen && lLen && tLen && bLen) {
      //   let allMaxMin = this.getObjMinMax(this.allPoints, ['x', 'y', 'z'])
      //   let lightCenter = this.$commonThreeD.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getAx(), this.$commonViewJs.getAy(), this.$commonViewJs.getAz()))
      //   console.log('lightCenter', lightCenter, 'allMaxMin', allMaxMin)
      //   if (lightCenter.z < allMaxMin.z.min) {
      //     this.backMesh = _createFaceMesh(this.allPoints, 'x', 'y')
      //     this.backMesh.position.setZ(-point.b2.z - this.wallOffset)
      //     this.addToScene(this.backMesh)
      //   } else {
      //     this.frontMesh = _createFaceMesh(this.allPoints, 'x', 'y')
      //     this.frontMesh.position.setZ(point.b2.z + this.wallOffset)
      //     this.addToScene(this.frontMesh)
      //   }
      // }
    },
    updateFlatColor () {
      this.scene.remove(this.frontMesh)
      this.scene.remove(this.sideMesh)
      this.scene.remove(this.topMesh)
      if (this.leftMesh) this.scene.remove(this.leftMesh)
      if (this.backMesh) this.scene.remove(this.backMesh)
      if (this.bottomMesh) this.scene.remove(this.bottomMesh)

      this.initFlatColor()
    },
    setDrawData (data) {
      var drawData = []
      for (var i = 0; i < data.length; i++) {
        drawData[i] = []
        for (var j = 0; j < data[i].length; j++) {
          drawData[i][j] = this.transTwoViewP(data[i][j])
        }
      }
      return drawData
    },
    /**
     * 将3d的坐标轴转化为2d的坐标轴
     */
    transTwoViewP (p) {
      var res = {}
      res.x = (p.x + this.houseInfo.roomW / 100 / 2) * 100
      res.y = (p.z + this.houseInfo.roomD / 100 / 2) * 100
      res.z = (-p.y + this.houseInfo.roomH / 100 / 2) * 100
      return res
    },
    getIntersectPoint (ray, isBigWall) {
      if (this.isLShaped01) {
        return this.getIntersectPointLShaped(ray, isBigWall)
      }
      // let frontIntersects = ray.intersectObject(this.curtainImg)
      let frontIntersects
      let lightCenter = this.$commonThreeD.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getAx(), this.$commonViewJs.getAy(), this.$commonViewJs.getAz()))
      if (this.isCurvedWallDisplay) {
        frontIntersects = ray.intersectObject(this.cylinderWithSideWallGeo)
        if (frontIntersects.length > 0) {
          return {'value': frontIntersects[0].point, 'position': 'front'}
        } else {
          // if (this.curveDirection === '1' && isBigWall) {
          //   frontIntersects = ray.intersectObject(this.frontBigWallImg)
          //   if (frontIntersects.length > 0) {
          //     return {'value': frontIntersects[0].point, 'position': 'planeFront'}
          //   } else {
          //     return {'value': lightCenter, 'position': 'center'}
          //   }
          // }
          return {'value': lightCenter, 'position': 'center'}
        }
      } else {
        if (this.isSimple || isBigWall) {
          // 超出墙之后的点
          frontIntersects = ray.intersectObject(this.frontBigWallImg)
        } else {
          // 不超出墙
          frontIntersects = ray.intersectObject(this.curtainImg)
        }
        if (frontIntersects.length > 0) {
          return {'value': frontIntersects[0].point, 'position': 'front'}
        }
        let leftIntersects = ray.intersectObject(this.leftWallImg)
        if (leftIntersects.length > 0) {
          return {'value': leftIntersects[0].point, 'position': 'left'}
        }
        let rightIntersects = ray.intersectObject(this.rightWallImg)
        if (rightIntersects.length > 0) {
          return {'value': rightIntersects[0].point, 'position': 'right'}
        }
        let bottomIntersects = ray.intersectObject(this.floorCurtain)
        if (bottomIntersects.length > 0) {
          return {'value': bottomIntersects[0].point, 'position': 'bottom'}
        }

        let topIntersects = ray.intersectObject(this.roofCurtain)
        if (topIntersects.length > 0) {
          return {'value': topIntersects[0].point, 'position': 'top'}
        }
      }
      return {'value': lightCenter}
    },
    getIntersectPointLShaped (ray, isBigWall) {
      let objects, positions
      let intersects
      if (this.position === 0) {
        let roofObj = isBigWall ? this.roofBigWallImg : this.roofCurtain
        objects = [roofObj, this.curtainImg, this.leftWallImg, this.backWallImg, this.rightWallImg, this.floorCurtain]
        positions = ['top', 'front', 'left', 'back', 'right', 'bottom']
      } else {
        let floorObj = isBigWall ? this.floorBigWallImg : this.floorCurtain
        objects = [floorObj, this.curtainImg, this.leftWallImg, this.backWallImg, this.rightWallImg, this.roofCurtain]
        positions = ['bottom', 'front', 'left', 'back', 'right', 'top']
      }

      for (let i = 0; i < objects.length; i++) {
        intersects = ray.intersectObject(objects[i])
        if (intersects.length > 0) {
          // console.log('getIntersectPointLShaped', JSON.stringify(intersects[0].point), positions[i])
          return { 'value': intersects[0].point, 'position': positions[i] }
        }
      }
      let lightCenter = this.$commonThreeD.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getAx(), this.$commonViewJs.getAy(), this.$commonViewJs.getAz()))
      return { 'value': lightCenter }
    },
    getBigWallIntersectPoint (ray) {
      let object
      if (this.isLShaped01) {
        object = this.position === 1 ? this.floorBigWallImg : this.roofBigWallImg
      } else {
        object = this.frontBigWallImg
      }
      let bigWallIntersects = ray.intersectObject(object)
      // let bigWallIntersects = this.isCurvedWallDisplay ? ray.intersectObject(this.cylinder) : ray.intersectObject(this.frontBigWallImg)
      if (bigWallIntersects.length > 0) {
        return bigWallIntersects[0].point
      }
    },
    createCenterLine (startP, endP) {
      let meterial = new THREE.LineDashedMaterial({color: 0xff6666, dashSize: 1, gapSize: 1})
      var geometry = new THREE.Geometry()
      geometry.vertices.push(startP, endP)
      this.centerLine = new THREE.Line(geometry, meterial)
      // this.addToScene(this.centerLine)
    },
    // 从投影仪到投影区域的4条射线
    createEdgeLine (startP, endP) {
      let edgeLinesMtl = new THREE.LineBasicMaterial({color: this.getMtlColor(this.$constant.rectLineColor), linewidth: 1})
      let geometry = new THREE.Geometry()
      geometry.vertices.push(startP, endP)
      let line = new THREE.Line(geometry, edgeLinesMtl)
      if (this.browserType !== 'ie') {
        this.addToScene(line)
      }
      return line
    },
    // 投影仪 投影的边界线（浅黄色周边的灰色边框）
    // 凹凸面场合，和 曲面几何体没有交点的场合，绘制投影区域的边界线和射线
    createHelpLine (vertices) {
      let helpLinesMtl = new THREE.LineBasicMaterial({color: this.getMtlColor(this.$constant.rectLineColor), linewidth: 3})

      let helpLine = new THREE.Line(vertices, helpLinesMtl)
      if (this.browserType !== 'ie') {
        this.addToScene(helpLine)
      }
      return helpLine
    },
    createDashLine (vertices) {
      let helpLinesMtl = new THREE.LineDashedMaterial({color: this.getMtlColor(this.$constant.dashRemainLineColor), dashSize: 300, gapSize: 5})

      let dashLine = new THREE.Line(vertices, helpLinesMtl)
      if (this.browserType !== 'ie') {
        this.addToScene(dashLine)
      }
      return dashLine
    },
    createblackHelpLine (vertices) {
      let helpLinesMtl = new THREE.LineBasicMaterial({color: 0x141313, linewidth: 1})

      let helpLine = new THREE.Line(vertices, helpLinesMtl)
      if (this.browserType !== 'ie') {
        this.addToScene(helpLine)
      }
      return helpLine
    },
    createAvailableRangeLine (vertices) {
      let lineMtl = new THREE.LineBasicMaterial({color: 0x141313, linewidth: 1})

      let line = new THREE.Line(vertices, lineMtl)
      if (this.browserType !== 'ie') {
        this.addToScene(line)
      }
      return line
    },
    removeLines () {
      this.scene.remove(this.centerLine)
      this.scene.remove(this.leftTopLine)
      this.scene.remove(this.rightTopLine)
      this.scene.remove(this.rightBottomLine)
      this.scene.remove(this.leftBottomLine)
      this.scene.remove(this.helpLine)
      this.scene.remove(this.dashLine)
      this.scene.remove(this.blackHelpLine)
      this.scene.remove(this.availableLine)
      this.scene.remove(this.leftTopAreaMesh)
    },
    removePJModel () {
      this.transformCtrl && this.transformCtrl.detach()
      if (this.PJModelGroup && this.PJModelGroup.visible) {
        this.PJModelGroup.visible = false
      }
      // this.scene.remove(this.PJModelGroup)
    },
    updateObjectMatrix () {
      this.floor && this.floor.updateMatrix()
      this.floor && this.floor.updateMatrixWorld()
      // this.gridFloor && this.gridFloor.updateMatrix()
      // this.gridFloor && this.gridFloor.updateMatrixWorld()
      this.roof && this.roof.updateMatrix()
      this.roof && this.roof.updateMatrixWorld()
      this.curtainImg && this.curtainImg.updateMatrix()
      this.curtainImg && this.curtainImg.updateMatrixWorld()
      this.frontWallImg && this.frontWallImg.updateMatrix()
      this.frontWallImg && this.frontWallImg.updateMatrixWorld()
      this.frontBigWallImg && this.frontBigWallImg.updateMatrix()
      this.frontBigWallImg && this.frontBigWallImg.updateMatrixWorld()
      this.rightWallImg && this.rightWallImg.updateMatrix()
      this.rightWallImg && this.rightWallImg.updateMatrixWorld()
      this.leftWallImg && this.leftWallImg.updateMatrix()
      this.leftWallImg && this.leftWallImg.updateMatrixWorld()
      this.cylinder && this.cylinder.updateMatrix()
      this.cylinder && this.cylinder.updateMatrixWorld()
      this.cylinderWithSideWallGeo && this.cylinderWithSideWallGeo.updateMatrix()
      this.cylinderWithSideWallGeo && this.cylinderWithSideWallGeo.updateMatrixWorld()
      this.floorBigWallImg && this.floorBigWallImg.updateMatrix()
      this.floorBigWallImg && this.floorBigWallImg.updateMatrixWorld()
      this.roofBigWallImg && this.roofBigWallImg.updateMatrix()
      this.roofBigWallImg && this.roofBigWallImg.updateMatrixWorld()
      this.floorCurtain && this.floorCurtain.updateMatrix()
      this.floorCurtain && this.floorCurtain.updateMatrixWorld()
      this.roofCurtain && this.roofCurtain.updateMatrix()
      this.roofCurtain && this.roofCurtain.updateMatrixWorld()
      this.backWallImg && this.backWallImg.updateMatrix()
      this.backWallImg && this.backWallImg.updateMatrixWorld()
    },
    updateRoomGeometry () {
      let point = this.getRoomCubePoint()
      this.updateWall()
      this.updateFloorAndRoof()
      this.setRoomGeometryPosition(point)
    },
    updateWall () {
      let scalex = this.houseInfo.roomW ? this.houseInfo.roomW / this.roomWInit : 0.1
      let scaley = this.houseInfo.roomH ? this.houseInfo.roomH / this.roomHInit : 0.1
      let scalez = this.houseInfo.roomD ? this.houseInfo.roomD / this.roomDInit : 0.1
      for (let i = 0; i < 2; i++) {
        this.frontWall.children[i].scale.x = scalex
        this.frontWall.children[i].scale.y = scaley

        this.rightWall.children[i].scale.x = scalez
        this.rightWall.children[i].scale.y = scaley
      }
      this.frontWallImg.scale.x = scalex
      this.frontWallImg.scale.y = scaley
      this.curtainImg.scale.x = scalex
      this.curtainImg.scale.y = scaley
      this.frontBigWallImg.scale.x = scalex
      this.frontBigWallImg.scale.y = scaley
      this.rightWallImg.scale.x = scalez
      this.rightWallImg.scale.y = scaley
      this.leftWallImg.scale.x = scalez
      this.leftWallImg.scale.y = scaley
      this.backWallImg.scale.x = scalex
      this.backWallImg.scale.y = scaley
    },
    updateFloorAndRoof () {
      let scalex = this.houseInfo.roomW ? this.houseInfo.roomW / this.roomWInit : 0.1
      let scalez = this.houseInfo.roomD ? this.houseInfo.roomD / this.roomDInit : 0.1
      this.floor.scale.x = scalex
      this.floor.scale.y = scalez
      this.roof.scale.x = scalex
      this.roof.scale.y = scalez
      // this.floorBigWallImg.scale.x = scalex
      // this.floorBigWallImg.scale.y = scalez
      // this.roofBigWallImg.scale.x = scalex
      // this.roofBigWallImg.scale.y = scalez
      this.floorCurtain.scale.x = scalex
      this.floorCurtain.scale.y = scalez
      this.roofCurtain.scale.x = scalex
      this.roofCurtain.scale.y = scalez
    },
    updateCurtainAndBigWallPosition () {
      this.isLShaped01 = this.$commonViewJs.isLShaped01()
      let point = this.getRoomCubePoint()

      let pointTemp = point.b2.z + (this.isLShaped01 ? 0 : this.offsetVal)
      this.curtainImg.position.setZ(pointTemp)
      this.frontBigWallImg.position.setZ(pointTemp)

      this.rightWallImg.position.setZ(this.isLShaped01 ? 0 : this.offsetVal)
      this.leftWallImg.position.setZ(this.isLShaped01 ? 0 : this.offsetVal)
      this.floorCurtain.position.setZ(this.isLShaped01 ? 0 : this.offsetVal)
      this.roofCurtain.position.setZ(this.isLShaped01 ? 0 : this.offsetVal)

      pointTemp = point.c3.y + (this.isLShaped01 ? this.offsetVal : 0)
      this.floorBigWallImg.position.setY(pointTemp)
      this.floorCurtain.position.setY(pointTemp)

      pointTemp = -point.c3.y - (this.isLShaped01 ? this.offsetVal : 0)
      this.roofBigWallImg.position.setY(pointTemp)
      this.roofCurtain.position.setY(pointTemp)

      let offset = this.isLShaped01 ? this.position === 1 ? this.offsetVal : -this.offsetVal : 0
      this.curtainImg.position.setY(offset)
      this.frontBigWallImg.position.setY(offset)
      this.leftWallImg.position.setY(offset)
      this.rightWallImg.position.setY(offset)
      this.backWallImg.position.setY(offset)
    },

    updatePJModelPosition () {
      let pointA = this.$commonThreeD.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getAx(), this.$commonViewJs.getAy(), this.$commonViewJs.getAz()))
      this.PJModelGroup.position.set(pointA.x, pointA.y, pointA.z)
    },
    updatePjModelType () {
      this.removePJModel()
      this.setPJModelAttibuteAndAddToScene()
    },
    getMtlColor (value) {
      let color = '0x' + value.slice(1)
      return parseInt(color)
    },
    /**
     * 获取房间立方体的关键顶点坐标（已转换为 ThreeD 坐标系）
     * @returns {Object} 房间顶点坐标集合
     * @returns {THREE.Vector3} b1 - 前下左角 (0, 0, 0) - 房间原点
     * @returns {THREE.Vector3} b2 - 前下右角 (roomW, 0, 0)
     * @returns {THREE.Vector3} threeD1 - 前上左角 (0, 0, roomH)
     * @returns {THREE.Vector3} threeD2 - 前上右角 (roomW, 0, roomH)
     * @returns {THREE.Vector3} threeD3 - 后下右角 (roomW, roomD, 0)
     * @returns {THREE.Vector3} c1 - 后上左角 (0, roomD, roomH)
     * @returns {THREE.Vector3} c3 - 后上右角 (roomW, roomD, roomH)
     * @description
     * 坐标转换规则：原始坐标 (x, y, z) → ThreeD 坐标 (x', y', z')
     * - x' = (x - roomW/2) / 100  (宽度方向，居中)
     * - y' = -(z - roomH/2) / 100 (高度方向，取反)
     * - z' = (y - roomD/2) / 100  (深度方向)
     *
     * 房间顶点分布：
     *       z (深度)
     *       ↑
     *       |
     *   c1--+------c3     后上左 (c1)        后上右 (c3)
     *   /   |     /|      前上左 (threeD1)   前上右 (threeD2)
     *  /    |    / |      前下左 (b1)        前下右 (b2)
     * threeD1+--threeD2 |  后下右 (threeD3)
     * |     b1+--|--b2   (后下左未使用)
     * |    /    |  /
     * |   /     | /
     *   c3------+
     *  /
     * → x (宽度)
     */
    getRoomCubePoint () {
      let roomCubePoint = {}
      let b1 = this.$commonThreeD.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getB1x(), this.$commonViewJs.getB1y(), this.$commonViewJs.getB1z()))
      let b2 = this.$commonThreeD.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getB2x(), this.$commonViewJs.getB2y(), this.$commonViewJs.getB2z()))
      // let b3 = this.$commonThreeD.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getB3x(), this.$commonViewJs.getB3y(), this.$commonViewJs.getB3z()))
      let threeD1 = this.$commonThreeD.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.get3D1x(), this.$commonViewJs.get3D1y(), this.$commonViewJs.get3D1z()))
      let threeD2 = this.$commonThreeD.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.get3D2x(), this.$commonViewJs.get3D2y(), this.$commonViewJs.get3D2z()))
      let threeD3 = this.$commonThreeD.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.get3D3x(), this.$commonViewJs.get3D3y(), this.$commonViewJs.get3D3z()))
      let c1 = this.$commonThreeD.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getC1x(), this.$commonViewJs.getC1y(), this.$commonViewJs.getC1z()))
      let c3 = this.$commonThreeD.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getC3x(), this.$commonViewJs.getC3y(), this.$commonViewJs.getC3z()))
      roomCubePoint.b1 = b1
      roomCubePoint.b2 = b2
      roomCubePoint.threeD1 = threeD1
      roomCubePoint.threeD2 = threeD2
      roomCubePoint.threeD3 = threeD3
      roomCubePoint.c1 = c1
      roomCubePoint.c3 = c3
      return roomCubePoint
    },
    /**
     * 获取房间 6 个面的 8 个顶点坐标
     * @returns {Object} 包含 6 个面，每个面有 4 个顶点坐标
     * @property {Array} front - 前面 (原始 y=0): [左下，右下，右上，左上]
     * @property {Array} back - 后面 (原始 y=roomD): [左下，右下，右上，左上]
     * @property {Array} left - 左面 (原始 x=0): [前下，后下，后上，前上]
     * @property {Array} right - 右面 (原始 x=roomW): [前下，后下，后上，前上]
     * @property {Array} bottom - 底面/地面 (原始 z=0, ThreeD y 为负值): [前左，前右，后右，后左]
     * @property {Array} top - 顶面/屋顶 (原始 z=roomH, ThreeD y 为正值): [前左，前右，后右，后左]
     * @description
     * ThreeD 坐标系说明：
     * - x 轴：宽度方向（居中，原点在房间中心）
     * - y 轴：高度方向（屋顶 y 为正，地面 y 为负）
     * - z 轴：深度方向（前面 z 为负，后面 z 为正）
     */
    getRoomSixFacesCorners () {
      const roomW = this.$commonViewJs.getB2x() // 房间宽度
      const roomD = this.$commonViewJs.getC1y() // 房间深度
      const roomH = this.$commonViewJs.getC1z() // 房间高度

      // 获取 8 个顶点的 ThreeD 坐标
      // 注意：为了符合直觉（屋顶 y 为正，地面 y 为负），这里交换了 z=0 和 z=roomH 的顶点
      const vertices = {
        // 前面 (y=0)
        frontBottomLeft: this.$commonThreeD.transCoordToThreeD(new THREE.Vector3(0, 0, roomH)), // 地面：z=roomH → y 为负
        frontBottomRight: this.$commonThreeD.transCoordToThreeD(new THREE.Vector3(roomW, 0, roomH)), // 地面：z=roomH → y 为负
        frontTopLeft: this.$commonThreeD.transCoordToThreeD(new THREE.Vector3(0, 0, 0)), // 屋顶：z=0 → y 为正
        frontTopRight: this.$commonThreeD.transCoordToThreeD(new THREE.Vector3(roomW, 0, 0)), // 屋顶：z=0 → y 为正
        // 后面 (y=roomD)
        backBottomLeft: this.$commonThreeD.transCoordToThreeD(new THREE.Vector3(0, roomD, roomH)), // 地面：z=roomH → y 为负
        backBottomRight: this.$commonThreeD.transCoordToThreeD(new THREE.Vector3(roomW, roomD, roomH)), // 地面：z=roomH → y 为负
        backTopLeft: this.$commonThreeD.transCoordToThreeD(new THREE.Vector3(0, roomD, 0)), // 屋顶：z=0 → y 为正
        backTopRight: this.$commonThreeD.transCoordToThreeD(new THREE.Vector3(roomW, roomD, 0)) // 屋顶：z=0 → y 为正
      }

      return {
        // 前面 (y=0 的面)
        front: [
          vertices.frontBottomLeft, // 左下（地面）
          vertices.frontBottomRight, // 右下（地面）
          vertices.frontTopRight, // 右上（屋顶）
          vertices.frontTopLeft // 左上（屋顶）
        ],
        // 后面 (y=roomD 的面)
        back: [
          vertices.backBottomLeft, // 左下（地面）
          vertices.backBottomRight, // 右下（地面）
          vertices.backTopRight, // 右上（屋顶）
          vertices.backTopLeft // 左上（屋顶）
        ],
        // 左面 (x=0 的面)
        left: [
          vertices.frontBottomLeft, // 前下（地面）
          vertices.backBottomLeft, // 后下（地面）
          vertices.backTopLeft, // 后上（屋顶）
          vertices.frontTopLeft // 前上（屋顶）
        ],
        // 右面 (x=roomW 的面)
        right: [
          vertices.frontBottomRight, // 前下（地面）
          vertices.backBottomRight, // 后下（地面）
          vertices.backTopRight, // 后上（屋顶）
          vertices.frontTopRight // 前上（屋顶）
        ],
        // 底面/地面 (z=roomH 的面，y 值为负)
        bottom: [
          vertices.frontBottomLeft, // 前左（地面）
          vertices.frontBottomRight, // 前右（地面）
          vertices.backBottomRight, // 后右（地面）
          vertices.backBottomLeft // 后左（地面）
        ],
        // 顶面/屋顶 (z=0 的面，y 值为正)
        top: [
          vertices.frontTopLeft, // 前左（屋顶）
          vertices.frontTopRight, // 前右（屋顶）
          vertices.backTopRight, // 后右（屋顶）
          vertices.backTopLeft // 后左（屋顶）
        ]
      }
    },
    onTransformMouseDown (event) {
      this.isDraggingPj = true
    },
    onTransformMouseUp () {
      if (this.isDraggingPj) {
        this.isDraggingPj = false
        this.updatePJModelPosition()
        this.OrbitControls.enableRotate = true
      }
      // console.log('=== 完整相机状态 ===')
      // // 1. 位置（必须）
      // console.log('position:', this.activeCamera.position.x, this.activeCamera.position.y, this.activeCamera.position.z)
      // // 2. 旋转（四元数 - 最准确）
      // console.log('quaternion:', this.activeCamera.quaternion.x, this.activeCamera.quaternion.y, this.activeCamera.quaternion.z, this.activeCamera.quaternion.w)
      // // 3. 向上方向（重要）
      // console.log('up:', this.activeCamera.up.x, this.activeCamera.up.y, this.activeCamera.up.z)
      // // 4. 旋转的欧拉角（备用）
      // console.log('rotation:', this.activeCamera.rotation.x, this.activeCamera.rotation.y, this.activeCamera.rotation.z, this.activeCamera.rotation.order)
      // // 5. 投影矩阵参数（确保视野一致）
      // console.log('fov:', this.activeCamera.fov)
      // console.log('aspect:', this.activeCamera.aspect)
      // console.log('near:', this.activeCamera.near)
      // console.log('far:', this.activeCamera.far)
      // // 6. 完整矩阵（最完整的方式）
      // console.log('matrix:', this.activeCamera.matrix.elements.join(', '))
      // console.log(`切换到标签 ${this.searchTabActive}, 相机位置:`, this.activeCamera.position, 'target:', this.OrbitControls.target, 'rotation:', this.activeCamera.rotation)
    },
    reDrawLines () {
      this.createRay(this.aspectRatio, false)
      let lightCenter = this.$commonThreeD.transCoordToThreeD(new THREE.Vector3(this.$commonViewJs.getAx(), this.$commonViewJs.getAy(), this.$commonViewJs.getAz()))
      this.scene.remove(this.leftTopLine)
      this.scene.remove(this.rightTopLine)
      this.scene.remove(this.rightBottomLine)
      this.scene.remove(this.leftBottomLine)
      this.leftTopLine = this.createEdgeLine(lightCenter, this.leftTopP)
      this.rightTopLine = this.createEdgeLine(lightCenter, this.rightTopP)
      this.rightBottomLine = this.createEdgeLine(lightCenter, this.rightBottomP)
      this.leftBottomLine = this.createEdgeLine(lightCenter, this.leftBottomP)
      let rayX = lightCenter.x - this.leftTopP.x
      let rayY = lightCenter.y - this.leftTopP.y
      let rayZ = lightCenter.z - this.leftTopP.z

      let valX = -1 / rayZ * rayX - this.baseLTRay.x
      let valY = -1 / rayZ * rayY - this.baseLTRay.y

      let lensshiftV = 100 * valY / (this.baseLTRay.y - this.baseLBRay.y)
      let lensshiftH = 100 * valX / (this.baseRTRay.x - this.baseLTRay.x)
      lensshiftV = Number(lensshiftV).toFixed(0)
      lensshiftH = Number(lensshiftH).toFixed(0)
      this.SET_VLENSSHIFT(Number(lensshiftV))
      this.SET_HLENSSHIFT(Number(lensshiftH))
    },
    OnProjectorDrag (event) {
      let point = this.getRoomCubePoint()
      let wMax = Math.abs(point.b1.x) - this.limitData
      let hMax = Math.abs(point.b1.y) - this.limitData
      let depMax = Math.abs(point.b1.z) - this.limitData
      let dRangeByLens = this.$commonViewJs.getMinDisByLens()
      let dRangeByLensMax, dRangeByLensMin, dRangeByRoom, dMin, dMax
      if (this.isLShaped01) {
        let dzMax = this.$commonThreeD.transCoordToThreeDZ(dRangeByLens.maxDis)
        let dzMin = this.$commonThreeD.transCoordToThreeDZ(dRangeByLens.minDis)
        let dzRoomMax = this.$commonThreeD.transCoordToThreeDZ(this.$commonViewJs.getMaxDisByRoom())
        let dzOffset = this.$commonThreeD.transCoordToThreeDZ(this.offset)
        // console.log('dzMax', dzMax, 'dzMin', dzMin, 'dzRoomMax', dzRoomMax, 'point.c1.y', point.c1.y)
        dRangeByLensMax = this.position === 0 ? dzMax : -dzMax
        dRangeByLensMin = this.position === 0 ? dzMin : -dzMin
        dRangeByRoom = this.position === 0 ? dzRoomMax : -dzRoomMax
        if (this.position === 1) {
          dMin = this.isOutOfSpec ? -dzOffset : dRangeByLensMin
          dMax = this.isOutOfSpec ? Number.POSITIVE_INFINITY : Math.min(dRangeByLensMax, dRangeByRoom, -point.c1.y)
        } else {
          dMin = this.isOutOfSpec ? -Number.POSITIVE_INFINITY : Math.max(dRangeByLensMax, dRangeByRoom, point.c1.y)
          dMax = this.isOutOfSpec ? dzOffset : dRangeByLensMin
        }
      } else {
        dRangeByLensMax = this.$commonThreeD.transCoordToThreeDY(dRangeByLens.maxDis)
        dRangeByLensMin = this.$commonThreeD.transCoordToThreeDY(dRangeByLens.minDis)
        dMin = this.isOutOfSpec ? this.$commonThreeD.transCoordToThreeDY(this.offset + (this.curveDirection === '1' ? this.curveDepth : 0) + this.limitData) : dRangeByLensMin
        dRangeByRoom = this.$commonThreeD.transCoordToThreeDY(this.$commonViewJs.getMaxDisByRoom())
        dMax = this.isOutOfSpec ? Number.POSITIVE_INFINITY : Math.min(dRangeByLensMax, dRangeByRoom, point.c1.z)
      }
      let Px = event.target.worldPosition.x
      let Py = event.target.worldPosition.y
      let Pz = event.target.worldPosition.z
      let xOutOfRange = false
      let yOutOfRange = false
      let zOutOfRange = false
      this.outOfRange = false

      // console.log('dMin', dMin, 'dMax', dMax, 'Py', Py, 'Px', Px, 'Pz', Pz)

      let screenToLens, screen
      if (this.isLShaped01) {
        if ((Py < dMin || Py > dMax) && this.transformCtrl.axis.indexOf('Y') !== -1) {
          yOutOfRange = true
          Py < dMin ? Py = dMin : Py = dMax
        }
        if (this.position === 0) {
          screenToLens = this.transCoordToY(Py) - this.offset
        } else {
          screenToLens = this.houseInfo.roomH - this.transCoordToY(Py) - this.offset
        }
        screen = this.$commonViewJs.getScreenXyFromDist(screenToLens)
      } else {
        if ((Pz < dMin || Pz > dMax) && this.transformCtrl.axis.indexOf('Z') !== -1) {
          zOutOfRange = true
          Pz < dMin ? Pz = dMin : Pz = dMax
        }
        screenToLens = this.transCoordToZ(Pz) - this.offset - (this.curveDirection === '1' ? this.curveDepth : 0)
        screen = this.$commonViewJs.getScreenXyFromDist(screenToLens)
      }
      this.outRoomHeight = this.$commonViewJs.getMaxOutRoomH(screen.calY)
      this.outRoomWidth = this.$commonViewJs.getMaxOutRoomW(screen.calX)
      this.outRoomDepth = this.$commonViewJs.getMaxOutRoomD(screen.calY)
      wMax += this.outRoomWidth / this.ratio
      if (Math.abs(Px) > wMax && this.transformCtrl.axis.indexOf('X') !== -1) {
        xOutOfRange = true
        Px > 0 ? Px = wMax : Px = -wMax
      }
      if (this.isLShaped01) {
        if (Pz > 0) depMax += this.outRoomDepth / this.ratio
        if (Math.abs(Pz) > depMax && this.transformCtrl.axis.indexOf('Z') !== -1) {
          zOutOfRange = true
          Pz > 0 ? Pz = depMax : Pz = -depMax
        }
      } else {
        if (Py > 0) hMax += this.outRoomHeight / this.ratio
        if (Math.abs(Py) > hMax && this.transformCtrl.axis.indexOf('Y') !== -1) {
          yOutOfRange = true
          Py > 0 ? Py = hMax : Py = -hMax
        }
      }

      if (xOutOfRange || yOutOfRange || zOutOfRange) {
        this.outOfRange = true
        this.transformCtrl.dragging = false
      } else {
        this.outOfRange = false
        this.OrbitControls.enableRotate = false
        this.transformCtrl.dragging = true
      }

      this.PJX(this.transCoordToX(Px))
      this.isLShaped01 ? this.PJY(this.transCoordToZ(Pz)) : this.PJY(screenToLens)
      this.isLShaped01 ? this.$commonViewJs.setPJZ(screenToLens) : this.PJZ(this.transCoordToY(Py))
      this.SCREENSIZE(this.$commonViewJs.getScreenByFromDistWide(screenToLens))
      this.SCRNW(screen.calX)
      this.SCRNH(screen.calY)
      if (this.isLShaped01) {
        if (Math.abs(point.c1.y) < Math.abs(Py)) {
          this.SET_GRAPH_ROOMH(Math.abs(Py) * 2 * 100 + this.limitData)
        }
      } else {
        if (point.c1.z < Math.abs(Pz)) {
          this.SET_GRAPH_ROOMD(Math.abs(Pz) * 2 * 100)
        }
      }
      // if (dRangeByRoom < Pz) {
      //   if (this.houseInfo.roomW <= screen.calX) {
      //     this.SET_GRAPH_ROOMW(screen.calX)
      //   }
      //   if (this.houseInfo.roomH <= screen.calY) {
      //     this.SET_GRAPH_ROOMH(screen.calY)
      //   }
      // }
    },
    transCoordToX (val) {
      return this.ratio * val + this.houseInfo.roomW / 2
    },
    transCoordToY (val) {
      return this.ratio * (-val) + this.houseInfo.roomH / 2
    },
    transCoordToZ (val) {
      return this.ratio * val + this.houseInfo.roomD / 2
    },
    animate () {
      window.requestAnimationFrame(this.animate.bind(this))
      this.renderer.render(this.scene, this.activeCamera)
    },

    capture () {
      var image = new Image()
      this.renderer.render(this.scene, this.activeCamera)

      let imgData = this.renderer.domElement.toDataURL('image/jpeg')
      image.src = imgData
      document.body.appendChild(image)
    },
    updateMaterialColor (newColor) {
      if (this.cylinderGeo && this.cylinderGeo.material) {
        this.cylinderGeo.material.color.set(newColor)
      }
    }
  },
  computed: {
    ...mapState(['graph', 'houseInfo', 'pjImgType', 'vAngle', 'aspectRatio', 'selectedModelData', 'selectedLensData', 'vAngleFlag', 'hAngleFlag',
      'throwDistanceChecked', 'screenSizeChecked', 'vLensShiftNow', 'hLensShiftNow', 'initScreenSize', 'offset', 'dashFlag', 'USTLenshiftV', 'indAngleSwitch',
      'dashData', 'hAngle', 'dashDataRemain', 'position', 'limitData', 'screen4Point', 'threeDPJChecked', 'screenSize', 'browserType', 'isUSTWall', 'indAngleRemainPints',
      'isOutOfSpec', 'curveShape', 'curveDirection', 'curveCenter', 'curveDepth', 'curveRadius', 'curveCentralAngle', 'curveChordLength', 'isCurvedSupportedPJ', 'isSimple', 'selectRatioData', 'searchTabActive', 'isTouch',
      'curveScreenHeight', 'projectionCoverScreen']),
    coverScreenColor: {
      get () {
        return this.projectionCoverScreen ? this.$constant.greenColor : this.$constant.redColor
      }
    },
    throw_distance_checked: {
      get () {
        return this.throwDistanceChecked
      }
    },
    screen_size_checked: {
      get () {
        return this.screenSizeChecked
      }
    },
    pjX () {
      return this.graph.pjX
    },
    pjY () {
      return this.graph.pjY
    },
    pjZ () {
      return this.graph.pjZ
    },
    vLensShiftMax () {
      return this.graph.vLensShift.max
    },
    vLensShiftMin () {
      return this.graph.vLensShift.min
    },
    hLensShiftMax () {
      return this.graph.hLensShift.max
    },
    hLensShiftMin () {
      return this.graph.hLensShift.min
    },
    vhLensShiftMax () {
      return isNaN(this.graph.vhLensShift.max) ? 0 : this.graph.vhLensShift.max
    },
    vhLensShiftMin () {
      return isNaN(this.graph.vhLensShift.min) ? 0 : this.graph.vhLensShift.min
    },
    offsetVal () {
      return this.offset / 100
    },
    isCheckBoxDisable () {
      return this.screen_size_checked || this.throw_distance_checked
    },
    threeD_PJChecked: {
      get () {
        return this.threeDPJChecked
      },
      set (val) {
        if (val) {
          this.transformCtrl && this.transformCtrl.attach(this.PJModelGroup)
        } else {
          this.transformCtrl && this.transformCtrl.detach()
        }
        this.SET_THREEDPJCHECKED(val)
      }
    },
    projectorImgType: {
      get () {
        if (this.selectedModelData.lensExchange && this.selectedLensData &&
        this.selectedLensData.id && this.selectedLensData.id.indexOf('LX04H') > -1) {
          return 3
        } else if (this.selectedModelData.lensExchange && this.selectedLensData &&
        this.selectedLensData.id && this.selectedLensData.id.indexOf('LX') > -1) {
          return 2
        } else {
          return this.pjImgType
        }
      },
      set (val) {
        if (this.browserType !== 'ie') {
          this.updatePjModelType()
        }
      }
    },
    isCurvedWallDisplay () {
      return Boolean(this.searchTabActive === 'CurvedSurface' && !this.isUSTWall)
    }
  },
  watch: {
    coverScreenColor (newColor) {
      this.updateMaterialColor(newColor)
    },
    graph: {
      handler (newVal, oldVal) {
        if (!this.isDraggingPj || this.outOfRange) {
          if (this.PJModelGroup) {
            this.updatePJModelPosition()
          }
        }
        // if (this.screen_size_checked && this.throw_distance_checked) {
        //   this.reDrawLines()
        // } else {
        //   this.setLines()
        // }
        // if (!this.screen_size_checked) {
        //   // 获取黑边的长宽
        //   var initScreen = this.$commonViewJs.getInitScreenXyFromDist(this.graph.pjY)
        //   this.SET_INITSCREENSIZEW(initScreen.calX)
        //   this.SET_INITSCREENSIZEH(initScreen.calY)
        //   this.SCREENSIZE(this.$commonViewJs.getScreenByFromDistWide(this.graph.pjY))
        //   let screen = this.$commonViewJs.getScreenXyFromDist(this.graph.pjY)
        //   this.SCRNW(screen.calX)
        //   this.SCRNH(screen.calY)
        // }
        // this.isLShaped = this.$commonViewJs.isLShaped()
        // if (this.isLShaped) {
        if (this.offsetVal) {
          this.updateCurtainAndBigWallPosition()
        }
        //   this.debouncedSetLines()
        // }
        this.setLines()
      },
      deep: true
    },
    houseInfo: {
      handler (newValue, oldValue) {
        this.updateRoomGeometry()
        if (this.PJModelGroup) {
          this.updatePJModelPosition()
        }
        this.updateCurveWall()
        this.debouncedSetLines()
      },
      deep: true
    },
    hAngle: {
      handler (newValue, oldValue) {
        let val = this.$commonThreeD.getPJModelInitRotation(this.projectorImgType, this.position)
        this.$commonThreeD.setPjModelhAngle(newValue, this.PJModelGroup, this.projectorImgType, val, this.position)
        this.setLines()
      }
    },
    hAngleFlag: {
      handler (newValue, oldValue) {
        if (this.dashFlag) {
          this.SET_DASHDATAREMAIN(this.dashDatas)
        }
        this.setLines()
        let val = this.$commonThreeD.getPJModelInitRotation(this.projectorImgType, this.position)
        if (!newValue) {
          this.$commonThreeD.setPjModelhAngle(0, this.PJModelGroup, this.projectorImgType, val, this.position)
        } else {
          this.$commonThreeD.setPjModelhAngle(this.hAngle, this.PJModelGroup, this.projectorImgType, val, this.position)
        }
      }
    },
    vAngle: {
      handler (newValue, oldValue) {
        let val = this.$commonThreeD.getPJModelInitRotation(this.projectorImgType, this.position)
        this.$commonThreeD.setPjModelvAngle(newValue, this.PJModelGroup, this.projectorImgType, val)
        this.setLines()
      }
    },
    vAngleFlag: {
      handler (newValue, oldValue) {
        if (this.dashFlag) {
          this.SET_DASHDATAREMAIN(this.dashDatas)
        }
        this.setLines()
        let val = this.$commonThreeD.getPJModelInitRotation(this.projectorImgType, this.position)
        if (!newValue) {
          this.$commonThreeD.setPjModelvAngle(0, this.PJModelGroup, this.projectorImgType, val)
        } else {
          this.$commonThreeD.setPjModelvAngle(this.vAngle, this.PJModelGroup, this.projectorImgType, val)
        }
      }
    },

    // screen_size_checked: {
    //   handler (newValue, oldValue) {
    //     if (!newValue) {
    //       this.PJY(this.$commonViewJs.calScreensizeToDistanceWide(this.screenSize))
    //     }
    //     // this.setLines()
    //   }
    // },
    USTLenshiftV: {
      handler () {
        this.setLines()
      }
    },
    indAngleSwitch: {
      handler () {
        this.setLines()
      }
    },
    vLensShiftNow: {
      handler (newValue, oldValue) {
        if (!this.throw_distance_checked) {
          this.setLines()
        }
      }
    },
    hLensShiftNow: {
      handler (newValue, oldValue) {
        if (!this.throw_distance_checked) {
          this.setLines()
        }
      }
    },
    offsetVal: {
      handler (newValue, oldValue) {
        this.updatePJModelPosition()
        this.updateCurtainAndBigWallPosition()
        this.setLines()
      }
    },
    PJModel (val) {
      this.PJModelGroupType0 = val[0]
      this.PJModelGroupType1 = val[1]
      this.PJModelGroupType2 = val[2]
      this.PJModelGroupType3 = val[3]
      this.setPJModelAttibuteAndAddToScene()
    },
    isCheckBoxDisable (val) {
      this.threeD_PJChecked = !val
    },
    position (val) {
      this.isLShaped01 = this.$commonViewJs.isLShaped01()
      this.setPJModelRotation(val)
      this.isLShaped = this.$commonViewJs.isLShaped()
      if (this.isLShaped) {
        if (this.offsetVal) {
          this.updatePJModelPosition()
          this.updateCurtainAndBigWallPosition()
        }
        this.debouncedSetLines()
      }
    },
    selectedLensData (newValue, oldValue) {
      if (this.selectedModelData.lensExchange && this.selectedLensData &&
       this.selectedLensData.id && this.selectedLensData.id.indexOf('LX04H') > -1) {
        this.projectorImgType = 3
      } else if (this.selectedModelData.lensExchange && this.selectedLensData &&
       this.selectedLensData.id && this.selectedLensData.id.indexOf('LX') > -1) {
        this.projectorImgType = 2
      } else {
        this.projectorImgType = this.pjImgType
      }
      this.isLShaped = this.$commonViewJs.isLShaped()
      if (this.isLShaped) {
        this.debouncedSetLines()
      }
    },
    isOutOfSpec (val) {
      this.setLines()
    },
    curveShape () {
      this.debouncedSetLines()
    },
    curveDirection () {
      this.debouncedSetLines()
    },
    curveCenter () {
      this.debouncedSetLines()
    },
    isCurvedWallDisplay () {
      this.debouncedSetLines()
    },
    curveCentralAngle () {
      this.debouncedSetLines()
    },
    curveRadius () {
      this.debouncedSetLines()
    },
    curveChordLength () {
      this.debouncedSetLines()
    },
    curveDepth () {
      this.debouncedSetLines()
    },
    curveScreenHeight () {
      this.debouncedSetLines()
    }
  },
  created () {
    // 创建防抖函数，延迟 执行
    this.debouncedSetLines = debounce(this.setLines, 5)
  },
  mounted () {
    // radius, depth, td, len
    this.$commonJs.getConvexCurveLength(10, 2.707, 2.2)
    this.$commonJs.getConvexCurveLength(10, 2.707, 3.52)
    // this.$commonJs.getConcaveCurveLength(2.5, 1, 2.923, 1.346)
    // this.$commonJs.getRLRatio(6, 3.52, 2.707)
    this.init()
    if (this.PJModel.length !== 0 && this.browserType === 'other') {
      this.PJModelGroupType0 = this.PJModel[0]
      this.PJModelGroupType1 = this.PJModel[1]
      this.PJModelGroupType2 = this.PJModel[2]
      this.PJModelGroupType3 = this.PJModel[3]
      this.setPJModelAttibuteAndAddToScene()
    }
    if (this.browserType === 'edgeOrIE') {
      this.setPJModelAttibuteAndAddToScene()
    }
    this.animate()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onWindowResize, false)
    this.renderer.dispose()
    // 组件销毁时取消防抖函数
    this.debouncedSetLines.cancel()
  }
}
</script>

<style scoped>

.three-d-view {
  /* height: 345px; */
  width: 100%;
  height: 100%;
  background: #fff;
  text-align: center
}

.threed-img {
  background: url('../../assets/parts/icon/icon_3d.png') no-repeat center;
  width: 30px;
  height: 30px;
  float: left;
}
.notSupport3D {
  position: relative;
  top: 40%;
  transform: translateY(-50%);
}
</style>



// WEBPACK FOOTER //
// src/view/graph/threeDView.vue